// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:33:17.171Z
// Property: Mercantile River District (ID: 5712550654115840)
// Collections: 26 amenities, 21 floorplans (live), 36 photos, 83 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5712550654115840",
  "property_external_id": "4810271",
  "property_zillow_url": "https://www.zillow.com/homedetails/4921-White-Settlement-Rd-Fort-Worth-TX-76114/163421947_zpid/",
  "property_apartments_url": "https://www.apartments.com/mercantile-river-district-fort-worth-tx/lglktxe",
  "property_google_business_url": "https://www.google.com/maps/place/Mercantile+River+District/@32.7591415,-97.398997,17z/data=!4m13!1m7!3m6!1s0x864e7379d530fdaf:0x7d492c5730cbed72!2s4921+White+Settlement+Rd,+Fort+Worth,+TX+76114!3b1!8m2!3d32.7596438!4d-97.3972467!3m4!1s0x864e7379d2d665cb:0x9f9556ca36aef4f6!8m2!3d32.7596438!4d-97.3972467",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443276572",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "mercantile-river-district",
  "property_name": "Mercantile River District",
  "property_website_url": "https://www.mercantileriverdistrict.com/",
  "property_domain": "https://www.mercantileriverdistrict.com/",
  "property_address": "4921 White Settlement Rd",
  "property_full_address": "4921 White Settlement Rd, Fort Worth, TX 76114",
  "property_address_1": "4921 White Settlement Rd",
  "property_address_2": null,
  "property_address_city": "Fort Worth",
  "property_address_state": "TX",
  "property_address_zip_full": "76114-3918",
  "property_address_zip": "76114",
  "property_address_country": "US",
  "property_address_county": "Tarrant County",
  "property_neighborhood_address": "River District",
  "property_address_latitude": "32.7596438",
  "property_address_longitude": "-97.3972467",
  "property_email": "mercantile@alapts.com",
  "property_phone": "(682) 708-8484",
  "property_call_tracking_phone": "817-241-3734",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>River District energy, resort-style ease.</strong> Discover polished studio to three-bedroom homes with elevated finishes, smart-home touches, and relaxed spaces made for everyday recharge—then explore the floor plans and amenities that bring Mercantile River District to life.</p>",
  "property_long_description": "<p><strong>River District energy, resort-style ease.</strong> At Mercantile River District, you’re set near the West Fork Trinity River with quick access to the Trinity Trails, White Settlement Trailhead, and some of Fort Worth’s most talked-about local stops, including Heim Barbecue on the River, Salsa Limón, and Crystal Springs Hideaway. Downtown Fort Worth, the Cultural District, the Botanic Garden, and Panther Island are all within easy reach, giving your days a mix of riverfront recreation, dining, art, and city connection.</p><p>Inside the community, the experience feels polished but relaxed: float the lazy river, unwind by the waterside fire pit lounge, recharge in the fitness center, or meet the moment in the arcade-style game room, demonstration kitchen, business center, and package locker area. Your home brings the finish level with stainless-steel appliances, granite countertops, in-home washer and dryer, smart-home touches, and select layouts with wine fridges, Texas-sized balconies, private pet yards, or townhome-style garages. Explore studio to three-bedroom <a href=\"/floor-plans\">floor plans</a>, then see the full <a href=\"/amenities\">amenity collection</a> for the details that make everyday life feel elevated.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019d02f1-5f4c-72f8-9342-8c590bf2edd2.webp",
  "property_featured_image_media": {
    "alt_text": "Modern living room and kitchen with gray sofa, coffee table, and dark cabinetry.",
    "public_id": "019d02f1-5f4c-72f8-9342-8c590bf2edd2",
    "storage_key": "property/5712550654115840/019d02f1-5f4c-72f8-9342-8c590bf2edd2.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "325",
  "property_year_built": "2017",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.46153846153847",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $20 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8724085.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://mercantileriverdistrict.loftliving.com/login",
  "property_apply_now_url": "https://8724085.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e6fe0-e565-74ac-aca1-c8f9f52aa7bb.webp",
  "property_primary_logo_media": {
    "alt_text": "Mercantile River District Premier Apartments logo.",
    "public_id": "019e6fe0-e565-74ac-aca1-c8f9f52aa7bb",
    "storage_key": "property/5712550654115840/019e6fe0-e565-74ac-aca1-c8f9f52aa7bb.webp",
    "width": 1583,
    "height": 1081
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e6fe0-e55b-768c-aa40-814ffcf90d04.webp",
  "property_secondary_logo_media": {
    "alt_text": "Mercantile River District Premier Apartments logo",
    "public_id": "019e6fe0-e55b-768c-aa40-814ffcf90d04",
    "storage_key": "property/5712550654115840/019e6fe0-e55b-768c-aa40-814ffcf90d04.webp",
    "width": 1583,
    "height": 1081
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e6fe0-e55e-764a-8d20-038df4ec316a.webp",
  "property_icon_media": {
    "alt_text": "Property logo with crossed spears and circles.",
    "public_id": "019e6fe0-e55e-764a-8d20-038df4ec316a",
    "storage_key": "property/5712550654115840/019e6fe0-e55e-764a-8d20-038df4ec316a.webp",
    "width": 700,
    "height": 700
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e6fe0-e55e-764a-8d20-038df4ec316a.webp",
  "property_fav_icon_media": {
    "alt_text": "Property logo with crossed spears and circles.",
    "public_id": "019e6fe0-e55e-764a-8d20-038df4ec316a",
    "storage_key": "property/5712550654115840/019e6fe0-e55e-764a-8d20-038df4ec316a.webp",
    "width": 700,
    "height": 700
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f4303-4786-748b-a78f-b553165c5c78.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f4303-4786-748b-a78f-b553165c5c78",
    "storage_key": "property/5712550654115840/019f4303-4786-748b-a78f-b553165c5c78.webp",
    "width": 1280,
    "height": 874
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e6fe0-e565-74ac-aca1-c8f9f52aa7bb.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Mercantile River District Premier Apartments logo.",
    "public_id": "019e6fe0-e565-74ac-aca1-c8f9f52aa7bb",
    "storage_key": "property/5712550654115840/019e6fe0-e565-74ac-aca1-c8f9f52aa7bb.webp",
    "width": 1583,
    "height": 1081
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#313c4c",
  "property_secondary_color": "#c3552b",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#c3552b",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 3.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3.5",
  "property_sqft_range": "491 - 2031",
  "property_sqft_min": "491",
  "property_sqft_max": "2031",
  "property_price_range": "1303 - 2799",
  "property_price_min": "1303",
  "property_price_max": "2799",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/MercantileRiverDistrict",
  "property_instagram_url": "https://www.instagram.com/mercantileriverdistrict",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJy2XW0nlzToYR9vSuNspWlZ8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/elan-river-district-apartments-fort-worth",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Resort-style downtime, everyday ease.</strong> Float the lazy river, grill by the pool, unwind at the waterside fire pit, or recharge in the fitness center, game room, demo kitchen, and aqua massage space. Apartment finishes keep the polish going with granite countertops, stainless-steel appliances, in-home washers and dryers, USB-compatible outlets, and smart-home details, with select layouts adding wine fridges, spa showers, Texas-sized balconies, pet yards, or townhome-style garages.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with standout extras.</strong> Explore studio, one-, two-, and three-bedroom floor plans in Fort Worth’s River District, including a townhome-style option. Select homes raise the bar with Texas-sized balconies, private pet yards, wine fridges, spa showers, or garages, while every layout brings polished function with in-home washer and dryer, stainless-steel appliances, granite countertops, smart-home touches, and USB-compatible outlets.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the Mercantile River District look.</strong> Flip through sunlit interiors with dark designer cabinetry, granite counters, stainless-steel appliances, and open living space with a polished finish.</p><p>The gallery also captures the community’s standout spaces, including the resort-inspired pool, lazy river, waterside fire pit lounge, grilling areas, fitness center, arcade-style game room, select balconies, and pet-friendly outdoor areas.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Fort Worth starts at the river.</strong> From Mercantile River District, access the Trinity Trails near White Settlement, grab tacos at Salsa Limón or barbecue at Heim on the River, and unwind with a patio drink at Crystal Springs Hideaway. This west-side setting keeps the pace relaxed while putting the Cultural District, West 7th, Panther Island, and downtown within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>What stands out in the reviews?</strong> Mercantile River District earns praise for responsive management, friendly service, quick maintenance, and clean, well-kept grounds. Residents also point to spacious layouts, modern finishes, polished amenities, and a connected Fort Worth location that keeps daily routines easy. See why reviewers describe the community as comfortable, elevated, and a “Great Place to call Home.”</p>",
  "property_neighborhood_blurb": "<p><strong>Your Fort Worth map opens at the river.</strong> From Mercantile River District, the River District feels easygoing and connected: follow the West Fork Trinity River to the Trinity Trails, start a ride or run near the White Settlement trail access, then come back for tacos at Salsa Limón, barbecue at Heim on the River, or a patio drink at Crystal Springs Hideaway. The setting gives you a quieter west-side rhythm without losing the city—Fort Worth’s Cultural District, West 7th, Panther Island, and downtown are all close enough for dinner, museums, concerts, and weekend exploring.</p><p>Use the interactive map to see what is nearby, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience how this riverfront location connects with the <a href=\"/amenities\">community amenities</a> at home.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities with room to unwind, work, and host.</strong> At Mercantile River District, your day can move from a workout in the fully equipped fitness center to a float along the lazy river, a poolside grill session, or an evening by the waterside fire pit lounge. Inside, the classic arcade-style game room, demonstration kitchen, business center, aqua massage, package lockers, and elevator access in every building add comfort without complicating your routine.</p><p>Your home carries the same polished feel with stainless-steel appliances, sleek granite countertops, in-home washer and dryer, built-in refrigerator styling, USB-compatible outlets, and smart-home details. Select <a href=\"/floor-plans\">studio to three-bedroom layouts</a> raise the experience with wine fridges, spa showers, Texas-sized balconies, private pet yards, or townhome-style garages.</p>",
  "property_applynow_blurb": "<p><strong>Ready for River District living?</strong> Mercantile River District pairs polished apartment finishes with relaxed, resort-style energy near the Trinity Trails and Fort Worth favorites. Choose your studio, one-, two-, or three-bedroom layout and start your online application today.</p>",
  "property_contactus_blurb": "<p><strong>Questions? Need directions?</strong> Connect with the Mercantile River District leasing team for help finding your way, exploring studio to three-bedroom <a href=\"/floor-plans\">floor plans</a>, or learning more about the polished, relaxed lifestyle near the West Fork Trinity River. We’re here to make your next step easy.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Mercantile River District?</strong> Start here. This FAQ covers the essentials on leasing, floor plans, amenities, finishes, and everyday living in the community. If you need more details or want help finding the right fit, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that works the way you do.</strong> Mercantile River District gives you a wide range of apartment floor plans in Fort Worth’s River District, from streamlined studios and open one-bedrooms to roomy two-bedroom layouts and an expansive three-bedroom townhome-style option.</p><p>As you compare availability, look beyond bed and bath counts: select plans add elevated details like Texas-sized balconies, private pet yards, wine fridges, spa showers, or townhome-style garages. Every home is designed with polished everyday function in mind, including in-home washer and dryer, stainless-steel appliances, sleek granite countertops, built-in refrigerator styling, smart-home touches, and USB-compatible outlets. Explore the floor plan cards, picture your furniture in place, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout up close.</p>",
  "property_gallery_blurb": "<p><strong>See the details before you step inside.</strong> Browse photos of Mercantile River District and picture how each space comes together: sunlit kitchens with dark designer cabinetry, sleek granite counters, stainless-steel appliances, and open living areas ready for your personal style.</p><p>Outside the apartment interiors, the gallery follows the mood of the community—from the <a href=\"/amenities\">resort-inspired pool and lazy river</a> to the waterside fire pit lounge, grilling areas, fitness center, and classic arcade-style game room. You’ll also get a closer look at studio to three-bedroom layouts, select balconies, pet-friendly outdoor spaces, and polished finishes throughout. Want to keep exploring? Compare <a href=\"/floor-plans\">available floor plans</a> or book a <a href=\"/schedule-a-tour\">tour</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place in the River District.</strong> Use the interactive map to explore available <a href=\"/floor-plans\">studio to three-bedroom apartments</a>, then see how close Mercantile River District puts you to riverfront trails, local dining, arts, and downtown Fort Worth connection.</p>",
  "property_pets_blurb": "<p><strong>Space for paws, zoomies, and easy cleanups.</strong> At Mercantile River District, pet-friendly living is built into the day—not treated like an afterthought. Start with fresh air in the on-site pet play area, then head back to a home designed for real routines, with in-home washers and dryers, welcoming mud rooms for leashes and towels, and select layouts with private pet yards for extra outdoor breathing room.</p><p>Whether your cat prefers sunny lounge time or your dog is ready for the next walk, this River District setting keeps everyday outings simple while the community’s polished <a href=\"/amenities\">amenities</a> make staying close to home feel just as rewarding. Browse <a href=\"/floor-plans\">available layouts</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the pet-friendly features in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share the River District ease.</strong> Love the lazy river, polished apartment finishes, and quick access to Fort Worth favorites? Invite a friend to discover Mercantile River District and make resort-style living part of their everyday rhythm, too.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong> Log in to pay rent, submit maintenance requests, and manage your Mercantile River District account—all in one place, with the same polished, relaxed ease that defines life near the river.</p>",
  "property_reviews_blurb": "<p><strong>Resident experiences tell the story.</strong> As you read the reviews for Mercantile River District, you’ll notice a consistent theme: people appreciate the care behind the community. Residents highlight responsive management, friendly service, quick maintenance, and grounds that feel clean and well kept.</p><p>Reviews also point to spacious apartments, modern finishes, polished amenities, and a location that keeps daily life connected without feeling hectic. One resident called it a <strong>“Great Place to call Home,”</strong> while others praise the welcoming atmosphere and the team’s thoughtful communication. Browse the ratings below to see why so many residents describe life here as comfortable, elevated, and easy to enjoy.</p>",
  "property_created_at": "1750781522093",
  "property_scheduletour_blurb": "<p><strong>See the river-district rhythm in person.</strong> Tour Mercantile River District and picture polished, relaxed living—from the lazy river and waterside fire pit lounge to stainless-steel finishes, granite countertops, and smart-home touches. Explore the spaces, feel the setting, and book your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thanks—we received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture polished River District living with relaxed resort-style ease, smart-home finishes, and inviting spaces designed to make everyday life feel elevated at Mercantile River District.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through the spaces that matter most—right from your screen.</strong> Explore Mercantile River District’s virtual tours and get a clearer feel for the flow, finishes, and everyday function before you visit in person. Step inside available apartment tours including the S1 studio, A1, A2, A3, A7, and A9 one-bedroom layouts, plus the B1 two-bedroom option, then compare your favorites on the <a href=\"/floor-plans\">floor plans</a> page.</p><p>Beyond the apartments, take a closer look at community spaces built for work, movement, and downtime: the business center, conference room, clubroom, fitness center, and pool and lounge. When you are ready to see Mercantile River District from every angle, browse the tours here, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience it in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Mercantile River District",
  "property_seo_title_home": "Home | Apartments in Fort Worth TX",
  "property_seo_description_home": "Mercantile River District offers 1–3 bedroom apartments with spacious layouts and amenities near White Settlement Rd in Fort Worth.",
  "property_seo_title_floorplans": "Floor Plans | 1–3 Bedroom Apartments Fort Worth",
  "property_seo_description_floorplans": "Explore spacious 1, 2 & 3 bedroom apartments for rent at Mercantile River District near White Settlement Rd, Fort Worth TX.",
  "property_seo_title_amenities": "Amenities | Apartments near White Settlement Rd",
  "property_seo_description_amenities": "Enjoy resort-style amenities at Mercantile River District, located near White Settlement Rd in Fort Worth, TX.",
  "property_seo_title_gallery": "Gallery | Mercantile River District Apartments",
  "property_seo_description_gallery": "View photos of Mercantile River District apartments near White Settlement Rd in Fort Worth, TX.",
  "property_seo_title_virtualtours": "Virtual Tours | Mercantile River District TX",
  "property_seo_description_virtualtours": "Take a virtual tour of Mercantile River District apartments near White Settlement Rd in Fort Worth, TX.",
  "property_seo_title_interactivemap": "Interactive Leasing | Mercantile River District",
  "property_seo_description_interactivemap": "Use Mercantile River District’s interactive leasing tool to explore floor plans and apply online near White Settlement Rd.",
  "property_seo_title_neighborhood": "Neighborhood | Living in Fort Worth TX",
  "property_seo_description_neighborhood": "Live at Mercantile River District near White Settlement Rd, with easy access to Fort Worth dining, shopping & parks.",
  "property_seo_title_contact": "Contact | Apartments near White Settlement Rd",
  "property_seo_description_contact": "Contact Mercantile River District for leasing info and tours near White Settlement Rd in Fort Worth, TX.",
  "property_seo_title_faqs": "FAQ | Mercantile River District Apartments",
  "property_seo_description_faqs": "Find answers about leasing, pets, parking & more at Mercantile River District near White Settlement Rd in Fort Worth.",
  "property_seo_title_reviews": "Reviews | Mercantile River District Fort Worth",
  "property_seo_description_reviews": "See why residents love Mercantile River District apartments near White Settlement Rd in Fort Worth, TX.",
  "property_seo_title_applynow": "Apply Now | Fort Worth Apartments for Rent",
  "property_seo_description_applynow": "Apply now for 1–3 bedroom apartments at Mercantile River District near White Settlement Rd, Fort Worth TX.",
  "property_seo_title_residentaccess": "Resident Access | Mercantile River District TX",
  "property_seo_description_residentaccess": "Log in to the resident portal for Mercantile River District apartments near White Settlement Rd, Fort Worth TX.",
  "property_seo_title_referafriend": "Refer a Friend | Mercantile River District TX",
  "property_seo_description_referafriend": "Refer a friend to Mercantile River District and enjoy rewards in Fort Worth near White Settlement Rd.",
  "property_seo_title_scheduletour": "Schedule a Tour | Fort Worth River District",
  "property_seo_description_scheduletour": "Schedule a tour of Mercantile River District, 1–3 bedroom apartments near White Settlement Rd in Fort Worth, TX.",
  "property_seo_title_privacy": "Privacy Policy | Mercantile River District TX",
  "property_seo_description_privacy": "Learn how Mercantile River District near White Settlement Rd protects your privacy in Fort Worth, TX.",
  "property_seo_title_accessibility": "Accessibility | Mercantile River District TX",
  "property_seo_description_accessibility": "Mercantile River District is committed to digital accessibility for all residents in Fort Worth, TX.",
  "property_seo_title_sitemap": "Sitemap | Mercantile River District TX",
  "property_seo_description_sitemap": "Navigate the Mercantile River District website to find floor plans, amenities, and contact info in Fort Worth.",
  "property_seo_title_thankyou": "Thank You | Mercantile River District TX",
  "property_seo_description_thankyou": "See why residents love Mercantile River District apartments near White Settlement Rd in Fort Worth, TX.\n",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320213",
  "amenities": [
    {
      "id": "custom_ff1483db-78ef-426e-a1b5-16601327803d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_10aeec29-8544-4b0a-a503-196cdde94951",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Built-In Microwave",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b8733c9-21a8-4fa7-a3fe-91c44ce0abee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "WFH Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69b57300-160e-4aa4-ba79-ac5c07b33b71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry with Glass Inserts",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_55fce5b4-5c3a-4a14-b2ab-b3322ddd8e83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67b35fb9-e2b1-4d7e-aaad-497f909a8a4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000630",
      "title": "Elevators",
      "amount": "0.0000",
      "description": "Elevator Access in Every Building",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d8d6957-7e53-48f2-ba34-67743c976498",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000632",
      "title": "Fenced Yard",
      "amount": "0.0000",
      "description": "Private Pet Yards*",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ed6bce0-d7fb-4c79-bc62-fdd1322c208a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Crossfit Equipped Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8634785-438b-4155-8472-574cacea2cae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000639",
      "title": "Game Room",
      "amount": "0.0000",
      "description": "Classic Arcade-Style Game Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d543631-d389-43f7-bdbc-716b686f7786",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0330dd69-6c50-4976-a66a-f55a9937f31b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e4cd1aa0-68b9-440c-91d7-2be2e46ed984",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Texas-sized Balconies*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b8baf9ae-25af-432b-bc58-5f8503f4583c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "Resident Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5acce74f-edb2-4b16-85ed-8bccb5faeca9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Modern Resort Inspired Pool w/ Grilling Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38949d27-7cb8-45e2-8b6b-b32d03d190e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fdbb28ab-f40c-40a4-bdd1-e911e82d12a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Glass Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c4abc363-8ba7-431b-810d-3ab6f49254c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000696",
      "title": "Townhomes",
      "amount": "0.0000",
      "description": "Townhomes w/ Direct Access Garages*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21ef5812-ebce-49c8-8dbf-5f57f78ac369",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "Wall Outlets with USB Ports",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_de518a50-c672-48c5-b3c8-decba56495c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69a2662e-0d2a-47cb-8318-522ceac40e80",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000001022",
      "title": "TV Lounge",
      "amount": "0.0000",
      "description": "Resident Outdoor TV Lounges",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f07f1eb-3e20-495e-8f07-699fb7982b43",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000002364",
      "title": "Community Kitchen",
      "amount": "0.0000",
      "description": "Demonstration Kitchen for Entertaining",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b0f50c0-0acf-4aa3-8b6e-93c57790b124",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000002366",
      "title": "Aqua Massage",
      "amount": "0.0000",
      "description": "Soothing Aqua Massage",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_40cbe9e6-7121-40ec-b367-640e507c6a6f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000002367",
      "title": "Lazy River",
      "amount": "0.0000",
      "description": "Relaxing Lazy River w/ Waterside Fire Pit Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be153b2e-baf9-49a0-92ce-65106020b0b8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000002368",
      "title": "Wine Fridge",
      "amount": "0.0000",
      "description": "Chilling Wine Fridges*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_20ba0b75-b01c-42d7-be08-b183efe7dad3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000002369",
      "title": "Mud Room",
      "amount": "0.0000",
      "description": "Welcoming Mud Rooms",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f856dec4-0c6e-45f5-affa-b4027e26b821",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "external_id": "P000002370",
      "title": "Built-In Refrigerator",
      "amount": "0.0000",
      "description": "Seamless Built-In Refrigerators",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_1e81a84b-126d-4b4c-a623-c08c7736bd99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-f47f-72ab-916c-7059e4a21c55.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with a pool table, communal table, and seating.",
        "public_id": "019e89a2-f47f-72ab-916c-7059e4a21c55",
        "storage_key": "property/5712550654115840/019e89a2-f47f-72ab-916c-7059e4a21c55.webp",
        "width": 2632,
        "height": 1756
      },
      "title": "Community",
      "description": "Enjoy leisure time in our vibrant community lounge, featuring a billiards table, communal dining, and comfortable seating.",
      "link": "",
      "alt_text": "Stylish lounge area with a pool table, communal table, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fac9f4fa-9381-45bd-9dda-6953b8f13338",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-f260-710c-863a-e7d761ede404.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grilling stations and a swimming pool.",
        "public_id": "019e89a2-f260-710c-863a-e7d761ede404",
        "storage_key": "property/5712550654115840/019e89a2-f260-710c-863a-e7d761ede404.webp",
        "width": 2348,
        "height": 1565
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and relaxation in our community's outdoor oasis, complete with grilling stations and a sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor seating area with grilling stations and a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5658b696-11db-41e8-8e76-e0e375588315",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-ee53-7086-a892-36fbefeda5ab.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, copper pendant lights, and brick walls.",
        "public_id": "019e89a2-ee53-7086-a892-36fbefeda5ab",
        "storage_key": "property/5712550654115840/019e89a2-ee53-7086-a892-36fbefeda5ab.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a large island with bar seating, copper pendant lighting, and exposed brick accents. A walk-in pantry is visible in the background.",
      "link": "",
      "alt_text": "Modern kitchen with island, copper pendant lights, and brick walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c7d3e38-3dc8-422d-b46f-990a73d71581",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-edfc-74d7-817e-a82c7f5ae860.webp",
      "image_media": {
        "alt_text": "Modern lobby with a large central fireplace, comfortable seating areas, and a decorative wall.",
        "public_id": "019e89a2-edfc-74d7-817e-a82c7f5ae860",
        "storage_key": "property/5712550654115840/019e89a2-edfc-74d7-817e-a82c7f5ae860.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Experience the stylish and inviting atmosphere of our community lobby, featuring a striking fireplace and elegant decor.",
      "link": "",
      "alt_text": "Modern lobby with a large central fireplace, comfortable seating areas, and a decorative wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f0db2ef-bdc2-471c-9f63-8f338dd9ddd5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-e36c-71d9-83ce-602d8ec99ee4.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with a green sofa, fireplace, large TV, and record album art.",
        "public_id": "019e89a2-e36c-71d9-83ce-602d8ec99ee4",
        "storage_key": "property/5712550654115840/019e89a2-e36c-71d9-83ce-602d8ec99ee4.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our modern lounge, featuring a cozy fireplace, large entertainment screen, and unique decor with a retro vinyl record theme.",
      "link": "",
      "alt_text": "Stylish lounge area with a green sofa, fireplace, large TV, and record album art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cad3edb5-dc62-4202-87ff-30190d946233",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-d7fc-759d-95c8-0da4c77a7c34.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with modern lounge chairs and vibrant tile design.",
        "public_id": "019e89a2-d7fc-759d-95c8-0da4c77a7c34",
        "storage_key": "property/5712550654115840/019e89a2-d7fc-759d-95c8-0da4c77a7c34.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style pool, featuring unique tile accents and comfortable loungers for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with modern lounge chairs and vibrant tile design.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_81fc38da-4f53-40ee-9d6f-d749466e95b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-d914-756b-927b-8abcba8bc6af.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, unique headboard made of books, and a window overlooking a pool.",
        "public_id": "019e89a2-d914-756b-927b-8abcba8bc6af",
        "storage_key": "property/5712550654115840/019e89a2-d914-756b-927b-8abcba8bc6af.webp",
        "width": 2668,
        "height": 1781
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a stylish book-themed headboard, plush bedding, and a large window with a view of the community pool. Perfect for relaxation and comfort.",
      "link": "",
      "alt_text": "Bedroom with a bed, unique headboard made of books, and a window overlooking a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cbd82f96-d734-4231-807f-79943b715d65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-e529-74ca-b0e6-10de337c528b.webp",
      "image_media": {
        "alt_text": "Double vanity with granite countertops, modern cabinetry, and a large mirror.",
        "public_id": "019e89a2-e529-74ca-b0e6-10de337c528b",
        "storage_key": "property/5712550654115840/019e89a2-e529-74ca-b0e6-10de337c528b.webp",
        "width": 2580,
        "height": 1722
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a double vanity with granite countertops, modern dark wood cabinetry, a spacious walk-in closet, and a sleek toilet.",
      "link": "",
      "alt_text": "Double vanity with granite countertops, modern cabinetry, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_880b97e0-3105-4cc2-9552-8b7fdbdb28fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-e35e-7368-a97c-67225cc5b085.webp",
      "image_media": {
        "alt_text": "Modern apartment building with a resort-style pool and lounge chairs.",
        "public_id": "019e89a2-e35e-7368-a97c-67225cc5b085",
        "storage_key": "property/5712550654115840/019e89a2-e35e-7368-a97c-67225cc5b085.webp",
        "width": 2613,
        "height": 1742
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and lounge area at this modern apartment complex. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Modern apartment building with a resort-style pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_df4dcda9-6013-4127-a1c5-d24cecc9ca47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-da62-7449-b4e3-cf3a240fd3d8.webp",
      "image_media": {
        "alt_text": "Modern co-working space with computers and stylish seating.",
        "public_id": "019e89a2-da62-7449-b4e3-cf3a240fd3d8",
        "storage_key": "property/5712550654115840/019e89a2-da62-7449-b4e3-cf3a240fd3d8.webp",
        "width": 2607,
        "height": 1738
      },
      "title": "Community",
      "description": "Utilize our fully equipped co-working space, featuring high-speed internet, comfortable seating, and a professional atmosphere for productivity.",
      "link": "",
      "alt_text": "Modern co-working space with computers and stylish seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b25897f0-449b-4716-8ff3-8cf90b2ec222",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-d6c3-75f2-a060-83f37a461fe2.webp",
      "image_media": {
        "alt_text": "Row of treadmills and stationary bikes in a modern apartment gym with mirrors and orange ceiling.",
        "public_id": "019e89a2-d6c3-75f2-a060-83f37a461fe2",
        "storage_key": "property/5712550654115840/019e89a2-d6c3-75f2-a060-83f37a461fe2.webp",
        "width": 2585,
        "height": 1723
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Row of treadmills and stationary bikes in a modern apartment gym with mirrors and orange ceiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_07b16e47-e4fb-4aba-8677-79aaa4e647a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-de89-72ab-8a31-ce1e379e90b5.webp",
      "image_media": {
        "alt_text": "Closet with built-in shelves and hanging rods.",
        "public_id": "019e89a2-de89-72ab-8a31-ce1e379e90b5",
        "storage_key": "property/5712550654115840/019e89a2-de89-72ab-8a31-ce1e379e90b5.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space for organized storage.",
      "link": "",
      "alt_text": "Closet with built-in shelves and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5ab9aa07-f323-4bca-8ada-a6ed260d6b16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-d8ea-7697-9211-9cc4644c4ab1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a soaking tub, separate glass-enclosed shower, and a dual vanity with granite countertops.",
        "public_id": "019e89a2-d8ea-7697-9211-9cc4644c4ab1",
        "storage_key": "property/5712550654115840/019e89a2-d8ea-7697-9211-9cc4644c4ab1.webp",
        "width": 2656,
        "height": 1771
      },
      "title": "Apartment",
      "description": "Experience luxury in this stunning bathroom, featuring a deep soaking tub, a sleek glass shower, and a spacious dual vanity with elegant granite countertops.",
      "link": "",
      "alt_text": "Modern bathroom with a soaking tub, separate glass-enclosed shower, and a dual vanity with granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38d3adbf-1db5-400c-a6ce-dbf8cd5699c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-d351-71eb-96f7-e39be66edaf9.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a dresser, large bed with decorative pillows, and a ceiling fan.",
        "public_id": "019e89a2-d351-71eb-96f7-e39be66edaf9",
        "storage_key": "property/5712550654115840/019e89a2-d351-71eb-96f7-e39be66edaf9.webp",
        "width": 2645,
        "height": 1765
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bedroom, featuring a spacious bed, elegant dresser, and modern decor.",
      "link": "",
      "alt_text": "Stylish bedroom with a dresser, large bed with decorative pillows, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2f4f08c8-d5ea-49f5-8d4a-83ad162567cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-c831-708e-88ed-369c1bc8d2de.webp",
      "image_media": {
        "alt_text": "Convenience store with refrigerated drinks, snacks, and checkout kiosk.",
        "public_id": "019e89a2-c831-708e-88ed-369c1bc8d2de",
        "storage_key": "property/5712550654115840/019e89a2-c831-708e-88ed-369c1bc8d2de.webp",
        "width": 2526,
        "height": 1685
      },
      "title": "Community",
      "description": "Stock up on essentials and snacks at our on-site convenience store, featuring a variety of drinks, chips, and more, with a convenient self-checkout kiosk.",
      "link": "",
      "alt_text": "Convenience store with refrigerated drinks, snacks, and checkout kiosk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c9b5ee7e-8518-4e9b-a3c9-474241228bb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-c818-7532-bbea-49e897eddda0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinetry, stainless steel appliances, and a large island with bar stools.",
        "public_id": "019e89a2-c818-7532-bbea-49e897eddda0",
        "storage_key": "property/5712550654115840/019e89a2-c818-7532-bbea-49e897eddda0.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring sleek dark cabinets, a spacious granite island, and top-of-the-line stainless steel appliances. Perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinetry, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e134cfaa-702d-478d-9bf0-15d769e3c5c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-cb3d-7769-8fe9-35c48c839032.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity and granite countertops.",
        "public_id": "019e89a2-cb3d-7769-8fe9-35c48c839032",
        "storage_key": "property/5712550654115840/019e89a2-cb3d-7769-8fe9-35c48c839032.webp",
        "width": 2480,
        "height": 1654
      },
      "title": "Apartment",
      "description": "Enjoy a spa-like experience in this elegant bathroom, featuring a spacious double vanity with granite countertops, modern fixtures, and ample storage.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f23a9473-2893-4669-b58e-9d988b28a400",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-c58c-7561-b241-9de20b18602c.webp",
      "image_media": {
        "alt_text": "Community lounge with ping pong table, pool table, and TVs showing football.",
        "public_id": "019e89a2-c58c-7561-b241-9de20b18602c",
        "storage_key": "property/5712550654115840/019e89a2-c58c-7561-b241-9de20b18602c.webp",
        "width": 2667,
        "height": 1778
      },
      "title": "Community",
      "description": "Enjoy the community lounge featuring a ping pong table, pool table, and large screens for watching the big game. Perfect for socializing and recreation.",
      "link": "",
      "alt_text": "Community lounge with ping pong table, pool table, and TVs showing football.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4b3dd44-3d6d-4863-9784-69db6a719280",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-c174-72fa-8e80-dd52785dfd86.webp",
      "image_media": {
        "alt_text": "Rowing machine and two stationary bikes in a well-lit fitness center with wood accents and a TV.",
        "public_id": "019e89a2-c174-72fa-8e80-dd52785dfd86",
        "storage_key": "property/5712550654115840/019e89a2-c174-72fa-8e80-dd52785dfd86.webp",
        "width": 2325,
        "height": 1550
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a rowing machine and cardio bikes. Enjoy a workout with entertainment on our mounted TVs.",
      "link": "",
      "alt_text": "Rowing machine and two stationary bikes in a well-lit fitness center with wood accents and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f2d62c25-d04a-4c81-94dd-a46e10c7f3f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-c087-713a-ae9f-d6d15fcd5a51.webp",
      "image_media": {
        "alt_text": "Stylish communal lounge area with modern furniture and unique lighting.",
        "public_id": "019e89a2-c087-713a-ae9f-d6d15fcd5a51",
        "storage_key": "property/5712550654115840/019e89a2-c087-713a-ae9f-d6d15fcd5a51.webp",
        "width": 2459,
        "height": 1640
      },
      "title": "Community",
      "description": "Relax and socialize in our chic communal lounge, featuring comfortable seating, a large screen TV, and stylish decor.",
      "link": "",
      "alt_text": "Stylish communal lounge area with modern furniture and unique lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6577da4-49e0-4f84-bd42-5360de2ce06d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-c041-730a-9537-63474fd8674d.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with lounge chairs and a fire pit near a swimming pool.",
        "public_id": "019e89a2-c041-730a-9537-63474fd8674d",
        "storage_key": "property/5712550654115840/019e89a2-c041-730a-9537-63474fd8674d.webp",
        "width": 2315,
        "height": 1544
      },
      "title": "Community",
      "description": "Relax and unwind in our beautiful outdoor lounge area, complete with comfortable seating and a sparkling swimming pool, perfect for enjoying sunny days and cool evenings.",
      "link": "",
      "alt_text": "Outdoor seating area with lounge chairs and a fire pit near a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1ffc02d8-3a7d-4c72-84f8-38ced2cfca9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-c03e-75d8-a556-2be217052df8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and white tile backsplash.",
        "public_id": "019e89a2-c03e-75d8-a556-2be217052df8",
        "storage_key": "property/5712550654115840/019e89a2-c03e-75d8-a556-2be217052df8.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience culinary delight in this beautifully appointed kitchen, featuring sleek dark cabinetry, a gleaming stainless steel appliance suite, and a stylish white tile backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and white tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5714fef7-6fd2-46a2-930f-86b74af47e64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-bd7d-72f9-bc70-a1061fab8cbb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black cabinets, white countertops, stainless steel appliances, and a large island.",
        "public_id": "019e89a2-bd7d-72f9-bc70-a1061fab8cbb",
        "storage_key": "property/5712550654115840/019e89a2-bd7d-72f9-bc70-a1061fab8cbb.webp",
        "width": 2536,
        "height": 1691
      },
      "title": "Apartment",
      "description": "Experience culinary delights in this sleek kitchen, featuring dark cabinetry, quartz countertops, and a spacious island perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with black cabinets, white countertops, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1f51a1e-8ed2-4d38-80d1-65018f56fb99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-aefc-733a-988f-c2ef364375f1.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with modern lounge chairs and multi-colored tile bottom, surrounded by apartment buildings.",
        "public_id": "019e89a2-aefc-733a-988f-c2ef364375f1",
        "storage_key": "property/5712550654115840/019e89a2-aefc-733a-988f-c2ef364375f1.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, featuring a vibrant, colorful tile design and ample lounge seating. A perfect oasis for residents to enjoy sunny days.",
      "link": "",
      "alt_text": "Resort-style swimming pool with modern lounge chairs and multi-colored tile bottom, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1226b77-8f73-4685-9506-c728b346b6ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-b101-71d9-9269-643e829b30e0.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table, ping pong table, and seating.",
        "public_id": "019e89a2-b101-71d9-9269-643e829b30e0",
        "storage_key": "property/5712550654115840/019e89a2-b101-71d9-9269-643e829b30e0.webp",
        "width": 2604,
        "height": 1736
      },
      "title": "Community",
      "description": "Enjoy recreation and relaxation in our vibrant community lounge, featuring a pool table and ping pong table.",
      "link": "",
      "alt_text": "Community lounge with a pool table, ping pong table, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3d3c694d-bb4a-4657-bf69-e2e0673cc779",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-b068-713d-b7e4-c87eb33cdd81.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, decorative headboard, and a nightstand.",
        "public_id": "019e89a2-b068-713d-b7e4-c87eb33cdd81",
        "storage_key": "property/5712550654115840/019e89a2-b068-713d-b7e4-c87eb33cdd81.webp",
        "width": 2660,
        "height": 1775
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a comfortable queen-size bed with a unique wooden headboard adorned with textiles, a cozy nightstand, and a dresser.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, decorative headboard, and a nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1703c3c5-a0c0-4110-8564-4b9cfc728f15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-b152-708b-ab9e-4977d9c061e2.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, decorative pillows, coffee table, floor lamp, and window.",
        "public_id": "019e89a2-b152-708b-ab9e-4977d9c061e2",
        "storage_key": "property/5712550654115840/019e89a2-b152-708b-ab9e-4977d9c061e2.webp",
        "width": 2642,
        "height": 1762
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a gray sofa, accent chairs, and decorative elements perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with gray sofa, decorative pillows, coffee table, floor lamp, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e29de08-bb47-4944-b5a2-c3e3e09d45be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-a850-74ec-a1da-7860bbbb15e7.webp",
      "image_media": {
        "alt_text": "Modern apartment complex gym with cardio and weight machines.",
        "public_id": "019e89a2-a850-74ec-a1da-7860bbbb15e7",
        "storage_key": "property/5712550654115840/019e89a2-a850-74ec-a1da-7860bbbb15e7.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and strength training equipment. Perfect for your daily workout routine.",
      "link": "",
      "alt_text": "Modern apartment complex gym with cardio and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4db79bdd-bf79-445e-a968-6d6284823952",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-a7ed-74cf-a68d-4d477cd43767.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area with seating and grilling stations at a multifamily property.",
        "public_id": "019e89a2-a7ed-74cf-a68d-4d477cd43767",
        "storage_key": "property/5712550654115840/019e89a2-a7ed-74cf-a68d-4d477cd43767.webp",
        "width": 2124,
        "height": 1416
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling outdoor swimming pool, comfortable lounge seating, and convenient grilling stations. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area with seating and grilling stations at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0599982e-9a5e-4a9a-8d48-b651c70e379b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-a853-7258-85fd-1d95f317477d.webp",
      "image_media": {
        "alt_text": "Apartment community's fenced-in dog park with playground equipment, benches, and landscaping.",
        "public_id": "019e89a2-a853-7258-85fd-1d95f317477d",
        "storage_key": "property/5712550654115840/019e89a2-a853-7258-85fd-1d95f317477d.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, complete with agility equipment and comfortable seating for residents and their furry friends. Your pet will love playing here!",
      "link": "",
      "alt_text": "Apartment community's fenced-in dog park with playground equipment, benches, and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4c1b8f9-0b13-4b2b-b025-f62d295dcb81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-a75d-7229-97c7-859c2777e06e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island.",
        "public_id": "019e89a2-a75d-7229-97c7-859c2777e06e",
        "storage_key": "property/5712550654115840/019e89a2-a75d-7229-97c7-859c2777e06e.webp",
        "width": 2614,
        "height": 1744
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring dark cabinetry, a sleek stainless steel refrigerator, and a spacious island with a granite countertop, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b6ce348-188c-4c68-b08b-d2ffcab3dc74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-a84f-773a-a281-7c588d848db7.webp",
      "image_media": {
        "alt_text": "Luxurious apartment building lobby with plush seating and decorative wall.",
        "public_id": "019e89a2-a84f-773a-a281-7c588d848db7",
        "storage_key": "property/5712550654115840/019e89a2-a84f-773a-a281-7c588d848db7.webp",
        "width": 2504,
        "height": 2156
      },
      "title": "Community",
      "description": "Step into elegance: our apartment lobby features plush seating, ornate chandeliers, and a striking decorative wall, creating a warm and inviting atmosphere.",
      "link": "",
      "alt_text": "Luxurious apartment building lobby with plush seating and decorative wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_30207625-9cf7-4118-9be7-50b47bdec79c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-a7c2-7798-946d-d5eb371ccfaa.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertops, stainless steel sink, and pendant lighting.",
        "public_id": "019e89a2-a7c2-7798-946d-d5eb371ccfaa",
        "storage_key": "property/5712550654115840/019e89a2-a7c2-7798-946d-d5eb371ccfaa.webp",
        "width": 2575,
        "height": 1717
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island with a sink, perfect for cooking and entertaining. Open-concept living area visible in the background.",
      "link": "",
      "alt_text": "Modern kitchen island with granite countertops, stainless steel sink, and pendant lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_407ac659-9c8f-4ccb-9013-a9a006fb4013",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-929d-743c-b43c-ce3d137de0a2.webp",
      "image_media": {
        "alt_text": "An aquamassage SPA machine in a wellness room.",
        "public_id": "019e89a2-929d-743c-b43c-ce3d137de0a2",
        "storage_key": "property/5712550654115840/019e89a2-929d-743c-b43c-ce3d137de0a2.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and rejuvenate with our state-of-the-art aquamassage SPA, offering a unique hydro-massage experience for ultimate relaxation.",
      "link": "",
      "alt_text": "An aquamassage SPA machine in a wellness room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_beeb0aa3-9c69-4d0d-8b03-472a0fea06ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-92fa-7456-ad1e-f3064f895e95.webp",
      "image_media": {
        "alt_text": "Stylish living room and open kitchen with dark cabinets and stainless steel appliances.",
        "public_id": "019e89a2-92fa-7456-ad1e-f3064f895e95",
        "storage_key": "property/5712550654115840/019e89a2-92fa-7456-ad1e-f3064f895e95.webp",
        "width": 2643,
        "height": 1763
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully designed apartment featuring a spacious open-concept living area and a sleek, fully-equipped kitchen.",
      "link": "",
      "alt_text": "Stylish living room and open kitchen with dark cabinets and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d81d2b1d-4e6f-4e40-b5d1-f9a6d5676654",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e89a2-92a5-74be-92fb-cdbfd0e3f6ea.webp",
      "image_media": {
        "alt_text": "Game room with pool table, arcade game, and TVs showing football.",
        "public_id": "019e89a2-92a5-74be-92fb-cdbfd0e3f6ea",
        "storage_key": "property/5712550654115840/019e89a2-92a5-74be-92fb-cdbfd0e3f6ea.webp",
        "width": 2681,
        "height": 1788
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in our community game room, featuring a pool table, arcade games, and large screens perfect for watching the game.",
      "link": "",
      "alt_text": "Game room with pool table, arcade game, and TVs showing football.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_e992c37fdbb6f7bb63b35263",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Heim Barbecue on the River",
      "poi_type": "Restaurants",
      "poi_address": "5333 White Settlement Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "A menu specializing in smoked meats & comfort sides in a modern, rustic setting with outdoor tables.",
      "poi_long_description": "A menu specializing in smoked meats & comfort sides in a modern, rustic setting with outdoor tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-e345-727c-9ded-4597c806f576.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e345-727c-9ded-4597c806f576",
        "storage_key": "property/5712550654115840/019f14fe-e345-727c-9ded-4597c806f576.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.heimbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4766072966533494418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heim-barbecue-on-the-river",
      "poi_latitude": "32.7598894",
      "poi_longitude": "-97.4020446",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 682-707-5772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM932ZqpzToYRkjbSfxx-JEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_b65989bb0165ac03c00b96dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Salsa Limón",
      "poi_type": "Restaurants",
      "poi_address": "5012 White Settlement Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "Tacos, tortas & other Mexican street food are the focus of this informal eatery.",
      "poi_long_description": "Tacos, tortas & other Mexican street food are the focus of this informal eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-e930-717b-8c72-70fc4dd08054.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e930-717b-8c72-70fc4dd08054",
        "storage_key": "property/5712550654115840/019f14fe-e930-717b-8c72-70fc4dd08054.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://salsalimon.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=13196744029530028680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salsa-limn",
      "poi_latitude": "32.7602811",
      "poi_longitude": "-97.3978001",
      "poi_miles_from_property": "387 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 682-312-5744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUORzHlzToYRiPrkh8ZAJLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_7669db864f68d94fbf32df0c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "STEWART'S",
      "poi_type": "Restaurants",
      "poi_address": "4424 White Settlement Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-ec35-775f-9f2f-fad94576ea19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-ec35-775f-9f2f-fad94576ea19",
        "storage_key": "property/5712550654115840/019f14fe-ec35-775f-9f2f-fad94576ea19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.stewartscocktailclub.com/hours-location",
      "poi_directions_map_url": "https://maps.google.com/?cid=6594911452974098240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stewarts",
      "poi_latitude": "32.7615332",
      "poi_longitude": "-97.3859314",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-214-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-7753-75b8-ad88-d3bb7a2c7afc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7753-75b8-ad88-d3bb7a2c7afc",
        "storage_key": "property/5712550654115840/019f14ff-7753-75b8-ad88-d3bb7a2c7afc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7WM8KwBzToYRQCetbwbVhVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_aaa14593c051d184331b5931",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Gemelle",
      "poi_type": "Restaurants",
      "poi_address": "4400 White Settlement Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "Quirky, contemporary Italian-American eatery with a full bar, garden patio & bocce ball courts.",
      "poi_long_description": "Quirky, contemporary Italian-American eatery with a full bar, garden patio & bocce ball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-e65b-766d-b222-8d0914b420a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e65b-766d-b222-8d0914b420a0",
        "storage_key": "property/5712550654115840/019f14fe-e65b-766d-b222-8d0914b420a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gemelleftw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8290808363794095784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gemelle",
      "poi_latitude": "32.7619407",
      "poi_longitude": "-97.3847353",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-732-9535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBUQ_SjhzToYRqN7IwEfeDnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_9405ee082398d91c6148f50c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "River's Cocktail & Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "4850 White Settlement Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-dd08-76b9-b0da-78b6751476ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-dd08-76b9-b0da-78b6751476ab",
        "storage_key": "property/5712550654115840/019f14fe-dd08-76b9-b0da-78b6751476ab.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.riverscocktailbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8754349779422593508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rivers-cocktail--wine-bar",
      "poi_latitude": "32.7602473",
      "poi_longitude": "-97.3957974",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 817-791-0687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-7753-75b8-ad88-d3bb7a2c7afc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7753-75b8-ad88-d3bb7a2c7afc",
        "storage_key": "property/5712550654115840/019f14ff-7753-75b8-ad88-d3bb7a2c7afc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8dCLxRzToYR5MEA6r2yfXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cocktail_bar"
    },
    {
      "id": "ec_50101181e052de9af4ea906e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Lettuce Cook",
      "poi_type": "Restaurants",
      "poi_address": "5101 White Settlement Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "Informal eatery fixing breakfast fare as well as healthy options, sandwiches and salads.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-e733-704b-a42e-56d021b74e34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e733-704b-a42e-56d021b74e34",
        "storage_key": "property/5712550654115840/019f14fe-e733-704b-a42e-56d021b74e34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lettucecookgourmet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6455744022095728185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lettuce-cook",
      "poi_latitude": "32.7598079",
      "poi_longitude": "-97.3982166",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 817-989-2665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_xv0HlzToYROQ7e7ftol1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_5ecc5c7ca1d4dfc2c874ef55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "El Compadre Tacos",
      "poi_type": "Restaurants",
      "poi_address": "5321 White Settlement Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-de92-725a-abd9-5878b177cf27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-de92-725a-abd9-5878b177cf27",
        "storage_key": "property/5712550654115840/019f14fe-de92-725a-abd9-5878b177cf27.webp",
        "width": 1267,
        "height": 1249
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15701967246552846896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-compadre-tacos",
      "poi_latitude": "32.7597674",
      "poi_longitude": "-97.4008876",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 682-239-9212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOwxXgJlzToYRMNKZpQSY6Nk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "ec_4af4dd5a3a3aa8066fce0368",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Big Kat Burgers @Crystal Springs Hideaway",
      "poi_type": "Restaurants",
      "poi_address": "113 Roberts Cut Off Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "Counter-serve food truck dishing up award-winning burgers, fries, and other comfort foods, plus a bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-e286-715c-8627-9285231e0205.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-e286-715c-8627-9285231e0205",
        "storage_key": "property/5712550654115840/019f14fe-e286-715c-8627-9285231e0205.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bigkatburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11919477653253747222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-kat-burgers-crystal-springs-hideaway",
      "poi_latitude": "32.7612903",
      "poi_longitude": "-97.4001816",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 682-224-2583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQImpl2TM6wRFnJlBsZ9aqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_c5520c27998417f25236409c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Clay Pigeon Food & Drink",
      "poi_type": "Restaurants",
      "poi_address": "2731 White Settlement Rd, Fort Worth, TX 76107, USA",
      "poi_short_description": "Relaxing eatery offering housemade, locally sourced classic American fare & a lengthy wine list.",
      "poi_long_description": "Relaxing eatery offering housemade, locally sourced classic American fare & a lengthy wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-de33-70a3-bb5d-43148bcf1cfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-de33-70a3-bb5d-43148bcf1cfd",
        "storage_key": "property/5712550654115840/019f14fe-de33-70a3-bb5d-43148bcf1cfd.webp",
        "width": 1280,
        "height": 858
      },
      "poi_business_url": "http://www.claypigeonfd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9618871745580373685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clay-pigeon-food--drink",
      "poi_latitude": "32.7589",
      "poi_longitude": "-97.35608",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-882-8065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-eS6neNzToYRtRZcv-MYfYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_1ad6a51fcbb66b0f7f57828a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Avoca Coffee Roasters",
      "poi_type": "Restaurants",
      "poi_address": "835 Foch St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Single-origin, house-roasted beans yield coffee beverages plus baked goods in a casual space.",
      "poi_long_description": "Single-origin, house-roasted beans yield coffee beverages plus baked goods in a casual space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-df60-7483-973f-e518a6db1922.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-df60-7483-973f-e518a6db1922",
        "storage_key": "property/5712550654115840/019f14fe-df60-7483-973f-e518a6db1922.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "http://www.avocacoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13161977193904282092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avoca-coffee-roasters",
      "poi_latitude": "32.750176",
      "poi_longitude": "-97.3562866",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-878-4249",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-776c-7428-b027-cb2ae870e6f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-776c-7428-b027-cb2ae870e6f1",
        "storage_key": "property/5712550654115840/019f14ff-776c-7428-b027-cb2ae870e6f1.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJRQLzG95zToYR7Bl10IW8qLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_fb9b308c9a2a0fa64d32fc0e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Woodshed Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "3201 Riverfront Dr, Fort Worth, TX 76107, USA",
      "poi_short_description": "Laid-back eatery featuring river views & a leafy patio, plus grilled & roasted specialties.",
      "poi_long_description": "Laid-back eatery featuring river views & a leafy patio, plus grilled & roasted specialties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-eb91-7599-8bf9-33363f332450.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-eb91-7599-8bf9-33363f332450",
        "storage_key": "property/5712550654115840/019f14fe-eb91-7599-8bf9-33363f332450.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "http://www.woodshedsmokehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13720331527060481436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodshed-smokehouse",
      "poi_latitude": "32.7242447",
      "poi_longitude": "-97.3643344",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-877-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9xSfDJyToYRnGUIl9RoaL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_3b153336ec6e1e92b0c9c5f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Nativo Café y Bodega",
      "poi_type": "Restaurants",
      "poi_address": "1701 White Settlement Rd, Fort Worth, TX 76107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-f299-763e-9610-3f61ffe2d2ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-f299-763e-9610-3f61ffe2d2ed",
        "storage_key": "property/5712550654115840/019f14fe-f299-763e-9610-3f61ffe2d2ed.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.nativotx.com/pages/nativo-cafe-y-bodega?srsltid=AfmBOoqv5AcwxHJIiXCGzUaAXP2RpKttDPu0m-oKfb67tKsogWb5vUXG",
      "poi_directions_map_url": "https://maps.google.com/?cid=10594223376712350978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nativo-caf-y-bodega",
      "poi_latitude": "32.7586023",
      "poi_longitude": "-97.3441092",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-776c-7428-b027-cb2ae870e6f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-776c-7428-b027-cb2ae870e6f1",
        "storage_key": "property/5712550654115840/019f14ff-776c-7428-b027-cb2ae870e6f1.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJc2GhmIdxToYRAj0U0Ac-BpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_976b4ba29bce24d32766ebb4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Panther City BBQ",
      "poi_type": "Restaurants",
      "poi_address": "201 E Hattie St, Fort Worth, TX 76104, USA",
      "poi_short_description": "Oak-smoked meats, Southern & Tex-Mex sides & banana pudding are dispensed from a food truck.",
      "poi_long_description": "Oak-smoked meats, Southern & Tex-Mex sides & banana pudding are dispensed from a food truck.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-f7f6-70d5-beb8-8c678c63ce98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-f7f6-70d5-beb8-8c678c63ce98",
        "storage_key": "property/5712550654115840/019f14fe-f7f6-70d5-beb8-8c678c63ce98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://panthercitybbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15595074753480169803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panther-city-bbq",
      "poi_latitude": "32.7381809",
      "poi_longitude": "-97.3247504",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 682-250-4464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8bKwxxToYRSxnZrtzVbNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_7af0fd57a170b8834d6180c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Piattello Italian Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "5924 Convair Dr Unit 412, Fort Worth, TX 76109, USA",
      "poi_short_description": "Bright, cheery spot for seasonal, housemade pastas & pizzas, plus espresso drinks & cocktails.",
      "poi_long_description": "Bright, cheery spot for seasonal, housemade pastas & pizzas, plus espresso drinks & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-fb24-701f-b663-9b5bf0786d66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-fb24-701f-b663-9b5bf0786d66",
        "storage_key": "property/5712550654115840/019f14fe-fb24-701f-b663-9b5bf0786d66.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://piattelloitaliankitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3030446326765450189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piattello-italian-kitchen",
      "poi_latitude": "32.6994418",
      "poi_longitude": "-97.4138094",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 817-349-0484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBZcfAJVyToYRzfO90eBODio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_86a08f8ef214232da601ed41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "SDS Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "4924 White Settlement Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10434810755735321118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sds-food-mart",
      "poi_latitude": "32.760335",
      "poi_longitude": "-97.396852",
      "poi_miles_from_property": "325 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 817-732-8581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-775c-748b-a581-b2dd462df6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-775c-748b-a581-b2dd462df6a7",
        "storage_key": "property/5712550654115840/019f14ff-775c-748b-a581-b2dd462df6a7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJj0saOnhzToYRHnoHqhjlz5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_71e51f41a8f990802ce26a56",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "QuikTrip",
      "poi_type": "Shopping & Retail",
      "poi_address": "6301 Westworth Blvd, Westworth Village, TX 76114, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-f348-72c8-8f80-6965fc50c21a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-f348-72c8-8f80-6965fc50c21a",
        "storage_key": "property/5712550654115840/019f14fe-f348-72c8-8f80-6965fc50c21a.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/tx/westworth-village/6301-westworth-blvd?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQ1MjEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7539832109450908104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "32.7592479",
      "poi_longitude": "-97.4224614",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-731-6048",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-775c-748b-a581-b2dd462df6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-775c-748b-a581-b2dd462df6a7",
        "storage_key": "property/5712550654115840/019f14ff-775c-748b-a581-b2dd462df6a7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbJcXVtzToYRyNHnFVvdomg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_72922f3cac59959aa0a3aff1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6770 Westworth Blvd, Westworth Village, TX 76114, USA",
      "poi_short_description": "Chain featuring electronics, toys, clothing, food and other home essentials.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-f9fa-76ca-9a31-3a24b24d2503.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-f9fa-76ca-9a31-3a24b24d2503",
        "storage_key": "property/5712550654115840/019f14fe-f9fa-76ca-9a31-3a24b24d2503.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/940-westworth-village-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17777945888947589203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.7551921",
      "poi_longitude": "-97.4339103",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-570-9538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bc-75a9-806a-c1e1d5be5d36",
        "storage_key": "property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6Tpoy01zToYRU1DWKpjzt_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_b2646512362d392a43eedf19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 Alta Mere Dr, Fort Worth, TX 76116, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-fe4c-722f-ab5c-415525d58353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-fe4c-722f-ab5c-415525d58353",
        "storage_key": "property/5712550654115840/019f14fe-fe4c-722f-ab5c-415525d58353.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tx/fort-worth/700-alta-mere-dr/l841",
      "poi_directions_map_url": "https://maps.google.com/?cid=11106944803344180750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "32.7506521",
      "poi_longitude": "-97.4347346",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bd-73d4-bc34-a81e58f6c153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bd-73d4-bc34-a81e58f6c153",
        "storage_key": "property/5712550654115840/019f14fc-b0bd-73d4-bc34-a81e58f6c153.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGU99kUtzToYRDmYzl3PLI5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_b85fd9572c97dffcbdfbd314",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "600 TX-183, Fort Worth, TX 76116, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-fbf0-73aa-a12b-3db20c99bff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-fbf0-73aa-a12b-3db20c99bff4",
        "storage_key": "property/5712550654115840/019f14fe-fbf0-73aa-a12b-3db20c99bff4.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-Fort-Worth/1619?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1619-_-na-_-0-_-0&y_source=1_MTE4NDE1MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980603672945813558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "32.7520213",
      "poi_longitude": "-97.4349218",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-377-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bc-75a9-806a-c1e1d5be5d36",
        "storage_key": "property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJq3264k5zToYRNujw9KaoHkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_b2bc2d16645c4243a91dea76",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "576 S Cherry Ln, White Settlement, TX 76108, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-010b-730f-bb05-82a5c33a8a10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-010b-730f-bb05-82a5c33a8a10",
        "storage_key": "property/5712550654115840/019f14ff-010b-730f-bb05-82a5c33a8a10.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.familydollar.com/tx/white-settlement/576-s-cherry-lane?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9686083490940697397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "32.7569886",
      "poi_longitude": "-97.4515249",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 682-235-0567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bc-75a9-806a-c1e1d5be5d36",
        "storage_key": "property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtRvpJqUMToYRNbtLrp3ha4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_876a806eab26e63a204a52c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "1701 S Cherry Ln, Fort Worth, TX 76108, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fe-ff08-7017-bd3e-8ee07157f343.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-ff08-7017-bd3e-8ee07157f343",
        "storage_key": "property/5712550654115840/019f14fe-ff08-7017-bd3e-8ee07157f343.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/texas/fort-worth/store-0097",
      "poi_directions_map_url": "https://maps.google.com/?cid=3435635196249143086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "academy-sports--outdoors",
      "poi_latitude": "32.7413891",
      "poi_longitude": "-97.4504283",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-935-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bc-75a9-806a-c1e1d5be5d36",
        "storage_key": "property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-ZwZQcYMToYRLndCGgLUrS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "ec_79582ab66817a8ec5ed997c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "JCPenney",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 Green Oaks Rd, Fort Worth, TX 76116, USA",
      "poi_short_description": "Chain department store selling a wide selection of brand-name clothing, footwear, furniture & more.",
      "poi_long_description": "Chain department store selling a wide selection of brand-name clothing, footwear, furniture & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-0555-705c-bf1d-d421f929604a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0555-705c-bf1d-d421f929604a",
        "storage_key": "property/5712550654115840/019f14ff-0555-705c-bf1d-d421f929604a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jcpenney.com/locations/tx/fortworth/clothing-stores-fortworth-tx-1419.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10348569615669271710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jcpenney",
      "poi_latitude": "32.7407822",
      "poi_longitude": "-97.4378677",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-731-6371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bc-75a9-806a-c1e1d5be5d36",
        "storage_key": "property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpd_OoTRzToYRnhxegzyBnY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_2e8975cf04e2c787b8192f89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Overton Park Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "4740 SW Loop 820, Fort Worth, TX 76109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-1229-7397-9d88-9b140a4de179.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-1229-7397-9d88-9b140a4de179",
        "storage_key": "property/5712550654115840/019f14ff-1229-7397-9d88-9b140a4de179.webp",
        "width": 1280,
        "height": 879
      },
      "poi_business_url": "https://www.frpltd.com/properties/overton-park-plaza/directory",
      "poi_directions_map_url": "https://maps.google.com/?cid=7033047977059228241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overton-park-plaza",
      "poi_latitude": "32.6842168",
      "poi_longitude": "-97.3953239",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 214-953-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bc-75a9-806a-c1e1d5be5d36",
        "storage_key": "property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ_Jz74ByToYRURrlWN9nmmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_20568b0254de4491938a4f63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "La Gran Plaza de Fort Worth",
      "poi_type": "Shopping & Retail",
      "poi_address": "4200 South Fwy Mall, Fort Worth, TX 76115, USA",
      "poi_short_description": "Community shopping center offering 200+ stores, a movie theater & live entertainment on weekends.",
      "poi_long_description": "Community shopping center offering 200+ stores, a movie theater & live entertainment on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-098c-748c-a847-3b9be105cd63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-098c-748c-a847-3b9be105cd63",
        "storage_key": "property/5712550654115840/019f14ff-098c-748c-a847-3b9be105cd63.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lagranplazamall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=842039262798139534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-gran-plaza-de-fort-worth",
      "poi_latitude": "32.6872481",
      "poi_longitude": "-97.3245901",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 817-922-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bc-75a9-806a-c1e1d5be5d36",
        "storage_key": "property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe-OBz1V2ToYRjtADij-Grws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_48fcfafca619c406facce8a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "A.V. Cato Elementary School",
      "poi_type": "Education",
      "poi_address": "4501 Barbara Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-0992-7704-a472-e950999a7d88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0992-7704-a472-e950999a7d88",
        "storage_key": "property/5712550654115840/019f14ff-0992-7704-a472-e950999a7d88.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.castleberryisd.net/avc?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile&utm_content=avc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8585700401075394259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "av-cato-elementary-school",
      "poi_latitude": "32.76884",
      "poi_longitude": "-97.3872644",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-252-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ9F0PId0ToYR0xYHmgaJJnc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_04248232584c4afaf6f6ae96",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Irma Marsh Middle School",
      "poi_type": "Education",
      "poi_address": "415 Hagg Dr, River Oaks, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-0f19-756d-a590-1abbfb7f3632.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0f19-756d-a590-1abbfb7f3632",
        "storage_key": "property/5712550654115840/019f14ff-0f19-756d-a590-1abbfb7f3632.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.castleberryisd.net/imms?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile&utm_content=imms",
      "poi_directions_map_url": "https://maps.google.com/?cid=2488584807404562260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "irma-marsh-middle-school",
      "poi_latitude": "32.7661129",
      "poi_longitude": "-97.3918314",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-252-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc0DCfIFzToYRVGfIfrI6iSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_10e0f1159dcc15296c4381cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Castleberry Elementary School",
      "poi_type": "Education",
      "poi_address": "1100 Roberts Cut Off Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-0deb-7676-97fb-1ef0631c4cf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0deb-7676-97fb-1ef0631c4cf2",
        "storage_key": "property/5712550654115840/019f14ff-0deb-7676-97fb-1ef0631c4cf2.webp",
        "width": 1280,
        "height": 809
      },
      "poi_business_url": "https://www.castleberryisd.net/ce?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile&utm_content=ce",
      "poi_directions_map_url": "https://maps.google.com/?cid=14890236375825039123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "castleberry-elementary-school",
      "poi_latitude": "32.7781759",
      "poi_longitude": "-97.3982602",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-252-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZYq1wIZ0ToYRE7-mihe_pM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_192d73932810a995327f2ad6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Kids R Love Learning Center",
      "poi_type": "Education",
      "poi_address": "1107 Roberts Cut Off Rd, River Oaks, TX 76114, USA",
      "poi_short_description": "Daycare center with long-standing owners offering a learning environment for children.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-0ab6-739f-a116-cf4a06db5c37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-0ab6-739f-a116-cf4a06db5c37",
        "storage_key": "property/5712550654115840/019f14ff-0ab6-739f-a116-cf4a06db5c37.webp",
        "width": 986,
        "height": 380
      },
      "poi_business_url": "http://www.kidsrlove.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=506966518279032024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-r-love-learning-center",
      "poi_latitude": "32.7777967",
      "poi_longitude": "-97.4002204",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-626-8604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwYLpnYZ0ToYR2MwJw1wbCQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_d40ce3a0bddd7fcf67e406f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Joy James Academy of Leadership",
      "poi_type": "Education",
      "poi_address": "5300 Buchanan St, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-11bf-72dd-9ad9-b51f224707fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-11bf-72dd-9ad9-b51f224707fc",
        "storage_key": "property/5712550654115840/019f14ff-11bf-72dd-9ad9-b51f224707fc.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.castleberryisd.net/jja?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile&utm_content=jja",
      "poi_directions_map_url": "https://maps.google.com/?cid=335914451015695369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joy-james-academy-of-leadership",
      "poi_latitude": "32.8039832",
      "poi_longitude": "-97.4001008",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-252-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCUb1Vfd0ToYRCfy112loqQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_632b91ad649d65c6e073ebfe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Castleberry High School",
      "poi_type": "Education",
      "poi_address": "215 Churchill Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-167c-74b9-adba-e71e7ca0458d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-167c-74b9-adba-e71e7ca0458d",
        "storage_key": "property/5712550654115840/019f14ff-167c-74b9-adba-e71e7ca0458d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.castleberryisd.net/chs?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile&utm_content=chs",
      "poi_directions_map_url": "https://maps.google.com/?cid=5686023842597914771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "castleberry-high-school",
      "poi_latitude": "32.7617756",
      "poi_longitude": "-97.3924135",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-252-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFdBn94JzToYRk0hzGo_Q6E4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_b9c86d91fd288744f6b2acdd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "TRUCE Learning Center",
      "poi_type": "Education",
      "poi_address": "1101 Merritt St, River Oaks, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18048256326671733668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "truce-learning-center",
      "poi_latitude": "32.7780395",
      "poi_longitude": "-97.397676",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-252-2490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZzd1Ood0ToYRpBN3XoFJePo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_da4e8edef5f541c90357aa17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "River Oaks Child Development",
      "poi_type": "Education",
      "poi_address": "4907 Ohio Garden Rd, River Oaks, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-16ee-72ed-af2f-7484c60f6185.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-16ee-72ed-af2f-7484c60f6185",
        "storage_key": "property/5712550654115840/019f14ff-16ee-72ed-af2f-7484c60f6185.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://childcareassociates.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15104445640136304111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-oaks-child-development",
      "poi_latitude": "32.7766429",
      "poi_longitude": "-97.3940148",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-625-5622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB9yp4310ToYR76WFbUjFndE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_68d3003d4767e8c06b650507",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "YMCA Camp Carter Training Center",
      "poi_type": "Education",
      "poi_address": "6086 Anahuac Ave, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18417848647228081728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca-camp-carter-training-center",
      "poi_latitude": "32.7793871",
      "poi_longitude": "-97.4135648",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjU2GcgB1ToYRQEbwQMNXmf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_aa9e00e323983c564c1edd7d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Burton Hill Elementary (FWISD)",
      "poi_type": "Education",
      "poi_address": "519 Burton Hill Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-2293-704d-a735-368453b93c34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-2293-704d-a735-368453b93c34",
        "storage_key": "property/5712550654115840/019f14ff-2293-704d-a735-368453b93c34.webp",
        "width": 1280,
        "height": 989
      },
      "poi_business_url": "https://www.fwisd.org/BurtonHill",
      "poi_directions_map_url": "https://maps.google.com/?cid=16384514189422845903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burton-hill-elementary-fwisd",
      "poi_latitude": "32.75345",
      "poi_longitude": "-97.4061017",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-815-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzaqffG5zToYRz1_lrdh8YeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_faa54dd3ea72fd76ebe3724c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "The Secret Chambers Escape Room - Fort Worth",
      "poi_type": "Entertainment",
      "poi_address": "513 Alta Mere Dr, Fort Worth, TX 76114, USA",
      "poi_short_description": "Challenging puzzle-filled escape rooms with the pirate-, mafia, train and witch themes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-1603-760d-b9a3-0c234bfe58a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-1603-760d-b9a3-0c234bfe58a5",
        "storage_key": "property/5712550654115840/019f14ff-1603-760d-b9a3-0c234bfe58a5.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "https://www.thesecretchambers.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4680676072324414990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-secret-chambers-escape-room---fort-worth",
      "poi_latitude": "32.752024",
      "poi_longitude": "-97.430404",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-857-3555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRPyrDNzToYRDj6RpxYa9UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_cddec85a00aedabd0375462d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Cinemark Rave Ridgmar 13 and XD",
      "poi_type": "Entertainment",
      "poi_address": "2300 Green Oaks Rd, Fort Worth, TX 76116, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-1cbd-7218-afca-34c31e112a53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-1cbd-7218-afca-34c31e112a53",
        "storage_key": "property/5712550654115840/019f14ff-1cbd-7218-afca-34c31e112a53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-fort-worth/cinemark-rave-ridgmar-13-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5MTEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=282577557179218310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-rave-ridgmar-13-and-xd",
      "poi_latitude": "32.7394514",
      "poi_longitude": "-97.4375439",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-566-0025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-7758-733c-ac49-c146c8e00da7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-7758-733c-ac49-c146c8e00da7",
        "storage_key": "property/5712550654115840/019f14ff-7758-733c-ac49-c146c8e00da7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJsxBbajJzToYRhjkqhcrq6wM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_0c3fc7f5c43ded941d33907d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Wild Acre Restaurant & Beer Garden",
      "poi_type": "Entertainment",
      "poi_address": "1734 E El Paso St #190, Fort Worth, TX 76102, USA",
      "poi_short_description": "Family-friendly brewery featuring outdoor space, playgrounds and beer gardens, as well as burgers and other grub.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-3d97-743e-80c1-edab004d2e52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-3d97-743e-80c1-edab004d2e52",
        "storage_key": "property/5712550654115840/019f14fc-3d97-743e-80c1-edab004d2e52.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.wildacrebrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10995777901426485947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wild-acre-restaurant--beer-garden",
      "poi_latitude": "32.7436834",
      "poi_longitude": "-97.3086294",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 682-207-1750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b125-7468-9e44-96fc7c844b54",
        "storage_key": "property/5712550654115840/019f14fc-b125-7468-9e44-96fc7c844b54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB9b3YB1xToYRu6qdQ77ZmJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_85bfb4f41041303702f362ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Modern Art Museum of Fort Worth",
      "poi_type": "Entertainment",
      "poi_address": "3200 Darnell St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Acclaimed contemporary complex with a reflecting pool housing more than 3,000 post-WWII artworks.",
      "poi_long_description": "Acclaimed contemporary complex with a reflecting pool housing more than 3,000 post-WWII artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-1d11-77e9-a5f6-aa0a4ec284e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-1d11-77e9-a5f6-aa0a4ec284e1",
        "storage_key": "property/5712550654115840/019f14ff-1d11-77e9-a5f6-aa0a4ec284e1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.themodern.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12620084409265249041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "modern-art-museum-of-fort-worth",
      "poi_latitude": "32.7491803",
      "poi_longitude": "-97.3633072",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-738-9215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b13c-7176-961d-8dd9d86fdcf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b13c-7176-961d-8dd9d86fdcf0",
        "storage_key": "property/5712550654115840/019f14fc-b13c-7176-961d-8dd9d86fdcf0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5w_isJzToYREVuz-eeLI68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_2222566b84b611e46d0f729c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Kimbell Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "3333 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "Renowned Asian- & European-focused collection plus exhibits set in a Louis Kahn-designed building.",
      "poi_long_description": "Renowned Asian- & European-focused collection plus exhibits set in a Louis Kahn-designed building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-5d8b-714b-b02b-555ed64d053c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-5d8b-714b-b02b-555ed64d053c",
        "storage_key": "property/5712550654115840/019f14fc-5d8b-714b-b02b-555ed64d053c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kimbellart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7239859824201680144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kimbell-art-museum",
      "poi_latitude": "32.7485687",
      "poi_longitude": "-97.3649208",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-332-8451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b13c-7176-961d-8dd9d86fdcf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b13c-7176-961d-8dd9d86fdcf0",
        "storage_key": "property/5712550654115840/019f14fc-b13c-7176-961d-8dd9d86fdcf0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_3ggMJzToYREMUp1SYmeWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_f005c12a07ac9f73faf0ced5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Amon Carter Museum of American Art",
      "poi_type": "Entertainment",
      "poi_address": "3501 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "Western artworks including those by Remington & Russell, plus Hudson River School paintings & more.",
      "poi_long_description": "Western artworks including those by Remington & Russell, plus Hudson River School paintings & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-2a60-764d-aeee-9f38ba4dfcb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-2a60-764d-aeee-9f38ba4dfcb9",
        "storage_key": "property/5712550654115840/019f14ff-2a60-764d-aeee-9f38ba4dfcb9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cartermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2896534922228772865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amon-carter-museum-of-american-art",
      "poi_latitude": "32.747867",
      "poi_longitude": "-97.368447",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-738-1933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b13c-7176-961d-8dd9d86fdcf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b13c-7176-961d-8dd9d86fdcf0",
        "storage_key": "property/5712550654115840/019f14fc-b13c-7176-961d-8dd9d86fdcf0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbcQcjcFzToYRAbD1TiqPMig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_93b1014446994402b933ee8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Fort Worth Museum of Science and History",
      "poi_type": "Entertainment",
      "poi_address": "1600 Gendy St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Hands-on science exhibits, a planetarium & IMAX films in a large-scale, child-friendly venue.",
      "poi_long_description": "Hands-on science exhibits, a planetarium & IMAX films in a large-scale, child-friendly venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-5566-7121-b30a-b4e8e6940cc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-5566-7121-b30a-b4e8e6940cc1",
        "storage_key": "property/5712550654115840/019f14fc-5566-7121-b30a-b4e8e6940cc1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fwmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3157640673865477658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-museum-of-science-and-history",
      "poi_latitude": "32.7441334",
      "poi_longitude": "-97.3692048",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-255-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b13c-7176-961d-8dd9d86fdcf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b13c-7176-961d-8dd9d86fdcf0",
        "storage_key": "property/5712550654115840/019f14fc-b13c-7176-961d-8dd9d86fdcf0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-dqJcFzToYRGq4ThnYx0is",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_fd144f5a5503d60106bbfc8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "National Cowgirl Museum & Hall of Fame",
      "poi_type": "Entertainment",
      "poi_address": "1720 Gendy St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Exhibits, films & gift shop celebrating women who shaped the American West & modern day heroines.",
      "poi_long_description": "Exhibits, films & gift shop celebrating women who shaped the American West & modern day heroines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-2619-7569-ad90-bf118fd93836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-2619-7569-ad90-bf118fd93836",
        "storage_key": "property/5712550654115840/019f14ff-2619-7569-ad90-bf118fd93836.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://www.cowgirl.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4068204186215491438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-cowgirl-museum--hall-of-fame",
      "poi_latitude": "32.7432988",
      "poi_longitude": "-97.3687909",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-336-4475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b13c-7176-961d-8dd9d86fdcf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b13c-7176-961d-8dd9d86fdcf0",
        "storage_key": "property/5712550654115840/019f14fc-b13c-7176-961d-8dd9d86fdcf0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0azVvMZzToYRbqchMScqdTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_2f926c0bfbcff7f4048bb19d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Fort Worth Stockyards Station",
      "poi_type": "Entertainment",
      "poi_address": "140 E Exchange Ave, Fort Worth, TX 76164, USA",
      "poi_short_description": "Large historic district with an Old West vibe offering tours, entertainment, shops & restaurants.",
      "poi_long_description": "Large historic district with an Old West vibe offering tours, entertainment, shops & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-375d-7798-a0f6-3c230e9282fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-375d-7798-a0f6-3c230e9282fc",
        "storage_key": "property/5712550654115840/019f14fc-375d-7798-a0f6-3c230e9282fc.webp",
        "width": 1280,
        "height": 809
      },
      "poi_business_url": "http://fortworthstockyards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6897670165128528122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-stockyards-station",
      "poi_latitude": "32.7886906",
      "poi_longitude": "-97.3452484",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-625-9715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bc-75a9-806a-c1e1d5be5d36",
        "storage_key": "property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhahdJ6R2ToYR-sBLQnhyuV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_9b11c48caea966e1aa06da4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Bass Performance Hall",
      "poi_type": "Entertainment",
      "poi_address": "525 Commerce St, Fort Worth, TX 76102, USA",
      "poi_short_description": "Elegant performing arts venue with multi-tiered seating for concerts, plays & other entertainment.",
      "poi_long_description": "Elegant performing arts venue with multi-tiered seating for concerts, plays & other entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-2ea7-748e-bd69-d90b31487c2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-2ea7-748e-bd69-d90b31487c2a",
        "storage_key": "property/5712550654115840/019f14ff-2ea7-748e-bd69-d90b31487c2a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.basshall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=935070752829437600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bass-performance-hall",
      "poi_latitude": "32.7548751",
      "poi_longitude": "-97.3298805",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-212-4280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXV_pgT9xToYRoHZBPuUJ-gw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_7fbb09279b0fad8bceaf3862",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Medical City Fort Worth",
      "poi_type": "Health and Wellness",
      "poi_address": "900 8th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-2873-721f-b75c-dd8f97ddd636.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-2873-721f-b75c-dd8f97ddd636",
        "storage_key": "property/5712550654115840/019f14ff-2873-721f-b75c-dd8f97ddd636.webp",
        "width": 493,
        "height": 277
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-fort-worth-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=524071590630840069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-fort-worth",
      "poi_latitude": "32.7358664",
      "poi_longitude": "-97.3452877",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-336-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d5-73f9-a4b4-ee7a56126fa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d5-73f9-a4b4-ee7a56126fa1",
        "storage_key": "property/5712550654115840/019f14fc-b0d5-73f9-a4b4-ee7a56126fa1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2QNkntxToYRBddsxFXgRQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_600467dfb4047c17820c4516",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Texas Health Breeze Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4480 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-2b81-72fa-beff-80aab39f6942.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-2b81-72fa-beff-80aab39f6942",
        "storage_key": "property/5712550654115840/019f14ff-2b81-72fa-beff-80aab39f6942.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://breeze.care.texashealth.org/locations/urgent-care-bryant-irvin-fort-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=13529406552902039019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-breeze-urgent-care",
      "poi_latitude": "32.685082",
      "poi_longitude": "-97.4146111",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 682-212-9160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyJwC29zToYR63WR95Mbwrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_f8cfc06a038ef146fb933ac3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - White Settlement",
      "poi_type": "Health and Wellness",
      "poi_address": "454 Jim Wright Fwy, White Settlement, TX 76108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-316e-7591-a709-757958b04933.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-316e-7591-a709-757958b04933",
        "storage_key": "property/5712550654115840/019f14ff-316e-7591-a709-757958b04933.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.carenow.com/locations/dallas-fort-worth/white-settlement?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12118770055734558991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---white-settlement",
      "poi_latitude": "32.7651786",
      "poi_longitude": "-97.4758071",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 682-703-4505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsflsHNANToYRDwGzXiiFLqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_8329395619d73fccc13b297c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5301 River Oaks Blvd, River Oaks, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-2deb-766d-973a-5c0414b17457.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-2deb-766d-973a-5c0414b17457",
        "storage_key": "property/5712550654115840/019f14ff-2deb-766d-973a-5c0414b17457.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/river-oaks-tx-pharmacies/5301-river-oaks-blvd-river-oaks-tx-76114/storeid=7678?WT.mc_id=LS_GOOGLE_RX_7678",
      "poi_directions_map_url": "https://maps.google.com/?cid=16412705574705356573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.771924",
      "poi_longitude": "-97.4001809",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-732-7713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-77b4-768e-b2a3-0d1fca273129.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-77b4-768e-b2a3-0d1fca273129",
        "storage_key": "property/5712550654115840/019f14ff-77b4-768e-b2a3-0d1fca273129.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD1VzIIJ0ToYRHd9iD8OkxeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_a5363e93572ce0c9d586bb8f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4921 Bryant Irvin Rd, Fort Worth, TX 76132, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-36ef-72be-8da7-d035342c4335.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-36ef-72be-8da7-d035342c4335",
        "storage_key": "property/5712550654115840/019f14ff-36ef-72be-8da7-d035342c4335.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4921+bryant+irvin+rd-fort+worth-tx-76132/id=4857",
      "poi_directions_map_url": "https://maps.google.com/?cid=13942275796046512473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.6778521",
      "poi_longitude": "-97.4153195",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 817-292-5806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUvRbGBtToYRWQHhl_fpfME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_acd07a1cdf2a7073ce491fce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Abundio's Fit Society",
      "poi_type": "Health and Wellness",
      "poi_address": "5725 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-33cd-760c-86e7-b76f627bf715.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-33cd-760c-86e7-b76f627bf715",
        "storage_key": "property/5712550654115840/019f14ff-33cd-760c-86e7-b76f627bf715.webp",
        "width": 1000,
        "height": 563
      },
      "poi_business_url": "http://www.abundiosfitsociety.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12980322199060135747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abundios-fit-society",
      "poi_latitude": "32.7309216",
      "poi_longitude": "-97.4090293",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-885-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc-7J_tzToYRQ78YcUReI7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_5fcc08251dd980a0657dcc42",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "6080 S Hulen St, Fort Worth, TX 76132, USA",
      "poi_short_description": "Big gym with free weights and cardio and strength-training equipment, plus basketball and sauna areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-3b85-739c-a3ab-843786d70733.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-3b85-739c-a3ab-843786d70733",
        "storage_key": "property/5712550654115840/019f14ff-3b85-739c-a3ab-843786d70733.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/hulen/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11618514866774949645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "32.6594452",
      "poi_longitude": "-97.4015306",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 817-361-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX2sFXXNtToYRDT-3u7ZBPaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0495870c7023fc18317e1bca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Indigo Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "5111 Pershing Ave, Fort Worth, TX 76107, USA",
      "poi_short_description": "Friendly, welcoming yoga studio providing classes for all skill levels, plus a clean space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-43d9-7048-a3a5-b75a046c0de3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-43d9-7048-a3a5-b75a046c0de3",
        "storage_key": "property/5712550654115840/019f14ff-43d9-7048-a3a5-b75a046c0de3.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.indigoyoga.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5248956417775981636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indigo-yoga",
      "poi_latitude": "32.735516",
      "poi_longitude": "-97.397465",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-735-9642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyfb9SKZzToYRRFQLQw0K2Eg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_b72ebdd81c3a0a70865154a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "YogaSix Fort Worth",
      "poi_type": "Health and Wellness",
      "poi_address": "5924 Convair Dr Unit 452, Fort Worth, TX 76109, USA",
      "poi_short_description": "Comfortable studio offering a variety of yoga classes for all levels.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-356b-719d-bb57-1abf9e58548c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-356b-719d-bb57-1abf9e58548c",
        "storage_key": "property/5712550654115840/019f14ff-356b-719d-bb57-1abf9e58548c.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "http://www.yogasix.com/fort-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=1844886238604914994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix-fort-worth",
      "poi_latitude": "32.6989154",
      "poi_longitude": "-97.4138865",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 817-587-6997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXT6J8dZzToYRMnENZ0Jamhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_94f7ef1414410e06f5d200a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Perspire Sauna Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "3700 Vision Dr Unit 112, Fort Worth, TX 76109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-4106-746e-bfb0-a5142a038ba7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-4106-746e-bfb0-a5142a038ba7",
        "storage_key": "property/5712550654115840/019f14ff-4106-746e-bfb0-a5142a038ba7.webp",
        "width": 904,
        "height": 1280
      },
      "poi_business_url": "https://www.perspiresaunastudio.com/tx/fw-waterside/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16339221786962381433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perspire-sauna-studio",
      "poi_latitude": "32.7007332",
      "poi_longitude": "-97.4129957",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-810-0542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcw5hKchzToYReUo3dqWTwOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sauna"
    },
    {
      "id": "ec_a8f98aceeada7829ad753319",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "White Settlement Trailhead Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4570 White Settlement Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "Park featuring trails, picnic tables, and a public restroom, plus a kid-friendly hike.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-47c3-7248-b746-0d0400495758.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-47c3-7248-b746-0d0400495758",
        "storage_key": "property/5712550654115840/019f14ff-47c3-7248-b746-0d0400495758.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.trwd.com/recreation/locations/in-along-the-trinity-river/trinity-trails/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9152422197274875060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-settlement-trailhead-park",
      "poi_latitude": "32.7611431",
      "poi_longitude": "-97.3856485",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-335-2491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8XuPoVzToYRtBT4Ln_vA38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_019088aa4f21ea03b8f2a62f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Marion Sansom Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2501 Roberts Cut Off Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "Hiking & mountain-biking trails through forestland with a scenic waterfall & lake vistas.",
      "poi_long_description": "Hiking & mountain-biking trails through forestland with a scenic waterfall & lake vistas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-86f2-72b7-95b6-d2c8ed30e0bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-86f2-72b7-95b6-d2c8ed30e0bf",
        "storage_key": "property/5712550654115840/019f14fc-86f2-72b7-95b6-d2c8ed30e0bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fortworthtexas.gov/departments/parks/parks-and-trails/marion-sansom-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5627592339759742107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marion-sansom-park",
      "poi_latitude": "32.7955904",
      "poi_longitude": "-97.4132597",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-392-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0e2-70ad-8727-2d9d74820981",
        "storage_key": "property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9SOvTep0ToYRm7wWsGo5GU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2ab3daf8525a1ae9add7c951",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Burger's Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1200 Meandering Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "Leafy 30-acre park around a lifeguarded lake with a slide, diving boards, picnic tables & beaches.",
      "poi_long_description": "Leafy 30-acre park around a lifeguarded lake with a slide, diving boards, picnic tables & beaches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-5173-7309-9e08-156f49f7f5d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5173-7309-9e08-156f49f7f5d5",
        "storage_key": "property/5712550654115840/019f14ff-5173-7309-9e08-156f49f7f5d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.burgerslake.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=626338622182983607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burgers-lake",
      "poi_latitude": "32.78072",
      "poi_longitude": "-97.4188221",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-737-3414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqPr10ToYRtwdTjKgzsQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_a0e88f0f34a37e1d3d3e16b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Rockwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 N University Dr, Fort Worth, TX 76114, USA",
      "poi_short_description": "Riverside park with a redeveloped golf course, baseball fields, playground & city skyline views.",
      "poi_long_description": "Riverside park with a redeveloped golf course, baseball fields, playground & city skyline views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-5102-7638-8ab2-9c215e2e798b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5102-7638-8ab2-9c215e2e798b",
        "storage_key": "property/5712550654115840/019f14ff-5102-7638-8ab2-9c215e2e798b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fortworthtexas.gov/departments/parks/parks-and-trails/rockwood-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5504758676407734884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockwood-park",
      "poi_latitude": "32.7673733",
      "poi_longitude": "-97.3640389",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-392-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0e2-70ad-8727-2d9d74820981",
        "storage_key": "property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb5cWrIpzToYRZFKIydnUZEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0d4442ad10101c2b5343f623",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Anderson-Campbell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4141 Ohio Garden Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-4df0-761e-a095-1d36b5fe99d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-4df0-761e-a095-1d36b5fe99d4",
        "storage_key": "property/5712550654115840/019f14ff-4df0-761e-a095-1d36b5fe99d4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://fortworthtexas.gov/parks/info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=674591643766276546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anderson-campbell-park",
      "poi_latitude": "32.78013019999999",
      "poi_longitude": "-97.3804613",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-392-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0e2-70ad-8727-2d9d74820981",
        "storage_key": "property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJraPNpnF0ToYRwsEin4ahXAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_4c62c28ebd2c0edecf63942e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Lake Worth Park Baseball Field",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3501 Roberts Cut Off Rd, Fort Worth, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-5052-754c-bdc5-6c98a68c0b24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5052-754c-bdc5-6c98a68c0b24",
        "storage_key": "property/5712550654115840/019f14ff-5052-754c-bdc5-6c98a68c0b24.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4694326275726648811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-worth-park-baseball-field",
      "poi_latitude": "32.8100083",
      "poi_longitude": "-97.4139939",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJff_JYpl1ToYR6yV4TOCYJUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "ec_52a856d53f5375fad06d6d10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Casino Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Fort Worth, TX 76135, USA",
      "poi_short_description": "Tree-lined space featuring a playground, picnic tables and grassy fields.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-49a0-73ad-8c1e-c7f616d7a462.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-49a0-73ad-8c1e-c7f616d7a462",
        "storage_key": "property/5712550654115840/019f14ff-49a0-73ad-8c1e-c7f616d7a462.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.fortworthtexas.gov/departments/parks/parks-and-trails/casino-beach",
      "poi_directions_map_url": "https://maps.google.com/?cid=3645225478242412897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casino-beach-park",
      "poi_latitude": "32.8191576",
      "poi_longitude": "-97.4563261",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0e2-70ad-8727-2d9d74820981",
        "storage_key": "property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzz0U3QLToYRYanXXEJxljI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b954f7ec3cde87c9df8ba3a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Fort Worth Nature Center & Refuge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9601 Fossil Ridge Rd, Fort Worth, TX 76135, USA",
      "poi_short_description": "3,621-acre preserve with 20 miles of hiking trails, plus bison, gators, deer & myriad birds.",
      "poi_long_description": "3,621-acre preserve with 20 miles of hiking trails, plus bison, gators, deer & myriad birds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-4ea7-7149-a435-29288a08ea30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-4ea7-7149-a435-29288a08ea30",
        "storage_key": "property/5712550654115840/019f14ff-4ea7-7149-a435-29288a08ea30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fwnaturecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13366477628738055665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-nature-center--refuge",
      "poi_latitude": "32.844233",
      "poi_longitude": "-97.4755896",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 817-392-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0e2-70ad-8727-2d9d74820981",
        "storage_key": "property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX3FzEYYKToYR8S0jr5VEf7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_4a0aa2c658cbd89a26bb7a7f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Keenum-Shelton Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3217 Dakota Trail, Lake Worth, TX 76135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6008592138623756154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keenum-shelton-dog-park",
      "poi_latitude": "32.8042639",
      "poi_longitude": "-97.4403327",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0e2-70ad-8727-2d9d74820981",
        "storage_key": "property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqAy0LToYReqffFrfOYlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_85362febc7194397ec816d37",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "River Oaks Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "River Oaks, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10859296552461913689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-oaks-community-park",
      "poi_latitude": "32.7650118",
      "poi_longitude": "-97.3993484",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0e2-70ad-8727-2d9d74820981",
        "storage_key": "property/5712550654115840/019f14fc-b0e2-70ad-8727-2d9d74820981.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ762EHTBzToYRWc4d8K34s5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6f0b668d61bcfa861982f561",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Fort Worth Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "1001 Jones St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-8ec2-736c-9456-16f7fe668c06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-8ec2-736c-9456-16f7fe668c06",
        "storage_key": "property/5712550654115840/019f14fc-8ec2-736c-9456-16f7fe668c06.webp",
        "width": 1280,
        "height": 820
      },
      "poi_business_url": "http://ridetrinitymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16666534907176730361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-central",
      "poi_latitude": "32.7526669",
      "poi_longitude": "-97.3264798",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b128-7388-adbe-9725ac03d236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b128-7388-adbe-9725ac03d236",
        "storage_key": "property/5712550654115840/019f14fc-b128-7388-adbe-9725ac03d236.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbEKLz5xToYR-b7q6jFtS-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_e24125856930a74e7aebf5dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Fort Worth T&p",
      "poi_type": "Transportation & Transit",
      "poi_address": "221 W Lancaster Ave, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-8c05-7565-8032-8634c2750895.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-8c05-7565-8032-8634c2750895",
        "storage_key": "property/5712550654115840/019f14fc-8c05-7565-8032-8634c2750895.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/fort-worth-tp-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2586634399591785905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-tp",
      "poi_latitude": "32.7453226",
      "poi_longitude": "-97.3279067",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b128-7388-adbe-9725ac03d236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b128-7388-adbe-9725ac03d236",
        "storage_key": "property/5712550654115840/019f14fc-b128-7388-adbe-9725ac03d236.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TtRaxNxToYRsWV5J0iS5SM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_9f913224728897b6c6f27580",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "North Side TEXRail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2829 Decatur Ave, Fort Worth, TX 76106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-5634-710b-939e-e4077ccd553d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5634-710b-939e-e4077ccd553d",
        "storage_key": "property/5712550654115840/019f14ff-5634-710b-939e-e4077ccd553d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/north-side-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4400919903570678562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-side-texrail-station",
      "poi_latitude": "32.7956413",
      "poi_longitude": "-97.3374867",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKa6inyV3ToYRItNG0VU1Ez0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_efea424fb3387679651e37bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Mercantile Center Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "4233 N Beach St, Fort Worth, TX 76137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-5d26-72bf-b387-6089c46ec5d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5d26-72bf-b387-6089c46ec5d2",
        "storage_key": "property/5712550654115840/019f14ff-5d26-72bf-b387-6089c46ec5d2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8576246469015309317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercantile-center-station",
      "poi_latitude": "32.8195149",
      "poi_longitude": "-97.2933422",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSZcvQl3ToYRBQzbg7nyBHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_95d71188143b0e4b41d3c35a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "CentrePort/DFW Airport Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "14470 Statler Blvd, Fort Worth, TX 76155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-5f19-76e3-b45b-b6c5a175143f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5f19-76e3-b45b-b6c5a175143f",
        "storage_key": "property/5712550654115840/019f14ff-5f19-76e3-b45b-b6c5a175143f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/guide/transit-and-use/rail/rail-station-detail/centreport-dfw-airport-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619245285415004907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centreportdfw-airport-station",
      "poi_latitude": "32.8170102",
      "poi_longitude": "-97.0528488",
      "poi_miles_from_property": "23.3 mi",
      "poi_walking_minutes": "8 hours 37 mins",
      "poi_biking_minutes": "2 hours 24 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-77b9-770b-9786-e0ee16eee7f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-77b9-770b-9786-e0ee16eee7f1",
        "storage_key": "property/5712550654115840/019f14ff-77b9-770b-9786-e0ee16eee7f1.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7AqJ-KAToYR6ypjCQK3eBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_801e46707b4c0d0490844632",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Sierra Vista Transfer Center Bay - B",
      "poi_type": "Transportation & Transit",
      "poi_address": "Fort Worth, TX 76119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-5e65-7325-800c-2a600838da4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-5e65-7325-800c-2a600838da4b",
        "storage_key": "property/5712550654115840/019f14ff-5e65-7325-800c-2a600838da4b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1149167995416205742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sierra-vista-transfer-center-bay---b",
      "poi_latitude": "32.7053879",
      "poi_longitude": "-97.3057044",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTX4C_zRwToYRrtkHCjSq8g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_c7892a90e344242c9ec2b5e5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "La Gran Plaza de Fort Worth",
      "poi_type": "Transportation & Transit",
      "poi_address": "4200 South Fwy Mall, Fort Worth, TX 76115, USA",
      "poi_short_description": "Community shopping center offering 200+ stores, a movie theater & live entertainment on weekends.",
      "poi_long_description": "Community shopping center offering 200+ stores, a movie theater & live entertainment on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-098c-748c-a847-3b9be105cd63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-098c-748c-a847-3b9be105cd63",
        "storage_key": "property/5712550654115840/019f14ff-098c-748c-a847-3b9be105cd63.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lagranplazamall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=842039262798139534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-gran-plaza-de-fort-worth",
      "poi_latitude": "32.6872481",
      "poi_longitude": "-97.3245901",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 817-922-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bc-75a9-806a-c1e1d5be5d36",
        "storage_key": "property/5712550654115840/019f14fc-b0bc-75a9-806a-c1e1d5be5d36.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe-OBz1V2ToYRjtADij-Grws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_51a9746b0d3320c6a5f57ed6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Dr.Dennis Dunkins Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Fort Worth, TX 76103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-6233-70ef-a95e-382f803246a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-6233-70ef-a95e-382f803246a2",
        "storage_key": "property/5712550654115840/019f14ff-6233-70ef-a95e-382f803246a2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7693365384874031419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "drdennis-dunkins-transit-center",
      "poi_latitude": "32.7404137",
      "poi_longitude": "-97.2631558",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-77b2-752d-a4fe-9144586db583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-77b2-752d-a4fe-9144586db583",
        "storage_key": "property/5712550654115840/019f14ff-77b2-752d-a4fe-9144586db583.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJWQ9m3Xh6ToYRO_mzbA5TxGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_3575a45e37dce822a91e9a8c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-6443-7006-b9b4-20d7349640bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-6443-7006-b9b4-20d7349640bc",
        "storage_key": "property/5712550654115840/019f14ff-6443-7006-b9b4-20d7349640bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "26.7 mi",
      "poi_walking_minutes": "9 hours 54 mins",
      "poi_biking_minutes": "2 hours 55 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b13d-75a9-92d0-ac4332cf7c12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b13d-75a9-92d0-ac4332cf7c12",
        "storage_key": "property/5712550654115840/019f14fc-b13d-75a9-92d0-ac4332cf7c12.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_9f78520147660d6b609d244e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "UNT Health Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3500 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-6373-75b8-88dd-fc096216f4b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-6373-75b8-88dd-fc096216f4b3",
        "storage_key": "property/5712550654115840/019f14ff-6373-75b8-88dd-fc096216f4b3.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.unthealth.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17001576964368720476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unt-health-fort-worth",
      "poi_latitude": "32.7496982",
      "poi_longitude": "-97.3694771",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-735-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQcyAaOpzToYRXGKpviu88es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_785a13e7c6fe7581b9b1b809",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Texas Christian University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2800 S University Dr, Fort Worth, TX 76109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-449c-71cb-b57c-77dbb0b85e06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-449c-71cb-b57c-77dbb0b85e06",
        "storage_key": "property/5712550654115840/019f14fc-449c-71cb-b57c-77dbb0b85e06.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=375771055333629936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-christian-university",
      "poi_latitude": "32.7078531",
      "poi_longitude": "-97.3628041",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 817-257-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_b0MPT1yToYR8N8IrsgBNwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_22776b0202f0eeb3ceabbb93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "United States Air Force Plant 4",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lockheed Blvd, Fort Worth, TX 76108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cumulis.epa.gov/supercpad/cursites/csitinfo.cfm?id=0603610",
      "poi_directions_map_url": "https://maps.google.com/?cid=16010628610778343053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-air-force-plant-4",
      "poi_latitude": "32.7711827",
      "poi_longitude": "-97.4502721",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSVNmIQLToYRjSYmwOQtMd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_f365ae1d3dbcc0adf1ae033d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Naval Air Station Joint Reserve Base Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Coody Dr, Westworth Village, TX 76114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-6822-77d0-9456-758e56b83adc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-6822-77d0-9456-758e56b83adc",
        "storage_key": "property/5712550654115840/019f14ff-6822-77d0-9456-758e56b83adc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cnic.navy.mil/fortworth/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15538734546637660030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "naval-air-station-joint-reserve-base-fort-worth",
      "poi_latitude": "32.765145",
      "poi_longitude": "-97.4211979",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-77ba-72f9-b9c1-e560c6ed7049.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ff-77ba-72f9-b9c1-e560c6ed7049",
        "storage_key": "property/5712550654115840/019f14ff-77ba-72f9-b9c1-e560c6ed7049.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBfDGQy1zToYRfp9tD76spNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_ebd703307ee5721b0b6360e5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Cook Children's Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "801 7th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-76a3-736d-b97e-a73575b0c110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-76a3-736d-b97e-a73575b0c110",
        "storage_key": "property/5712550654115840/019f14fc-76a3-736d-b97e-a73575b0c110.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cookchildrens.org/medical-center/fort-worth/?utm_source=google&utm_medium=OrganicSearch&utm_campaign=yext&y_source=1_MTEzNzc5ODgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10985657874343977757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cook-childrens-medical-center",
      "poi_latitude": "32.737",
      "poi_longitude": "-97.340842",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 682-885-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d5-73f9-a4b4-ee7a56126fa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d5-73f9-a4b4-ee7a56126fa1",
        "storage_key": "property/5712550654115840/019f14fc-b0d5-73f9-a4b4-ee7a56126fa1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS7naHpxToYRHeM-2KHldJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_028b85df9f66c82704eb9b8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Medical City Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "900 8th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-2873-721f-b75c-dd8f97ddd636.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-2873-721f-b75c-dd8f97ddd636",
        "storage_key": "property/5712550654115840/019f14ff-2873-721f-b75c-dd8f97ddd636.webp",
        "width": 493,
        "height": 277
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-fort-worth-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=524071590630840069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-fort-worth",
      "poi_latitude": "32.7358664",
      "poi_longitude": "-97.3452877",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-336-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d5-73f9-a4b4-ee7a56126fa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d5-73f9-a4b4-ee7a56126fa1",
        "storage_key": "property/5712550654115840/019f14fc-b0d5-73f9-a4b4-ee7a56126fa1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2QNkntxToYRBddsxFXgRQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_ca05da6810472a4e0cfe72d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "John Peter Smith Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 S Main St, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-6dfe-712c-9a8e-fc66af674032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-6dfe-712c-9a8e-fc66af674032",
        "storage_key": "property/5712550654115840/019f14ff-6dfe-712c-9a8e-fc66af674032.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.jpshealthnet.org/locations/jpshospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12646798849451524257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-peter-smith-hospital",
      "poi_latitude": "32.7277649",
      "poi_longitude": "-97.3268923",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 817-702-3431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d5-73f9-a4b4-ee7a56126fa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d5-73f9-a4b4-ee7a56126fa1",
        "storage_key": "property/5712550654115840/019f14fc-b0d5-73f9-a4b4-ee7a56126fa1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8Ld8qBxToYRoYBgR4x0gq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_4e62c00388039ca1c08cd932",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "FWISD District Service Center (DSC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7060 Camp Bowie Blvd, Fort Worth, TX 76116, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-6818-7066-92dd-1387ac04dfdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-6818-7066-92dd-1387ac04dfdc",
        "storage_key": "property/5712550654115840/019f14ff-6818-7066-92dd-1387ac04dfdc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fwisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15134471432473832560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fwisd-district-service-center-dsc",
      "poi_latitude": "32.7207508",
      "poi_longitude": "-97.4377975",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-814-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0bf-76b3-a60f-0aa2b8f64d43",
        "storage_key": "property/5712550654115840/019f14fc-b0bf-76b3-a60f-0aa2b8f64d43.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2bsuPeVzToYRcGzm-5RxCNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_dc4c3f02c6eb5bf9a74fb20f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "Bell",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3255 Bell Flight Blvd, Fort Worth, TX 76118, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-69bc-7252-956b-f54eb70f9009.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-69bc-7252-956b-f54eb70f9009",
        "storage_key": "property/5712550654115840/019f14ff-69bc-7252-956b-f54eb70f9009.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bellflight.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2708728753638745052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell",
      "poi_latitude": "32.8080827",
      "poi_longitude": "-97.1564018",
      "poi_miles_from_property": "16.4 mi",
      "poi_walking_minutes": "6 hours 3 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 817-280-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fcbcMB-ToYR3COGMXNWlyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_f8aaef1590a37787f3f3899d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "poi_name": "American Airlines - Skyview 7",
      "poi_type": "Major Employers & Offices",
      "poi_address": "RWFJ+R6, Transformation Way, Fort Worth, TX 76155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14ff-67a6-734e-99af-42b080a06635.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-67a6-734e-99af-42b080a06635",
        "storage_key": "property/5712550654115840/019f14ff-67a6-734e-99af-42b080a06635.webp",
        "width": 1280,
        "height": 450
      },
      "poi_business_url": "http://www.aa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15492633573707074314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-airlines---skyview-7",
      "poi_latitude": "32.8291621",
      "poi_longitude": "-97.0659943",
      "poi_miles_from_property": "22.3 mi",
      "poi_walking_minutes": "8 hours 13 mins",
      "poi_biking_minutes": "2 hours 15 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 682-278-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-b0d3-776b-8837-064d2eaba0fa",
        "storage_key": "property/5712550654115840/019f14fc-b0d3-776b-8837-064d2eaba0fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHaLL45iBToYRCssZ3CbkANc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    }
  ],
  "office_hours": [
    {
      "id": "custom_415c025a-7b58-4a1c-ba02-b1103e423612",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_dfa6e78c-3807-40c8-860c-3e94043a77a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_01c5e983-183d-4e3f-9784-e9f1b193c727",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d2c6e076-62b4-44ee-a828-52fb0ca6f60a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_1175207b-da23-48c5-b011-9b0127fdba52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_655d8fc9-d262-42ff-a7f0-54da851a3def",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_38557f26-3462-4cd7-bb85-3588ebc928ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "rating": "5.0",
      "name": "maria corona",
      "text": "We moved in a couple weeks ago, and so far we have had a Great experience with Mercantile River District Apartments, especially thanks to Noelle . She helped us with everything from choosing what was right for us to explaining the leasing process and accommodating to our needs.\n\nWe were relocating from North Carolina to Texas, and Noelle  made the entire process incredibly easy! Saved us from some stress. We applied without seeing the apartment in person, and she handled everything over the phone with patience, professionalism, and kindness. She was always helpful, responsive, and made sure we felt confident every step of the way. Always Answering all and any of our questions or concerns.\n\nWe appreciate how smooth she made this big transition for us. Highly recommend Mercantile River District and especially Noelle!🌟🌟🌟🌟🌟",
      "date": "2026-01-21",
      "title": ""
    },
    {
      "id": "custom_03935f53-677d-4b6e-8a32-ffb396e20d05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "rating": "5.0",
      "name": "Allie Gannon",
      "text": "I recently had the pleasure of working with Noelle for my new resident experience. From the very first conversation, touring, applying, move in & after she has been phenomenal, she is knowledgeable about the community, can call the residents by name when she sees them, walks you through the process answers questions. This move in process has been a breeze thanks to her. Also the community itself is beautiful, grounds are well kept & everyone is so helpful.",
      "date": "2026-06-17",
      "title": ""
    },
    {
      "id": "custom_03078f29-e35c-4fff-8507-93314ffe0306",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "rating": "5.0",
      "name": "Ezekiel Ybarra",
      "text": "I love this area of Fort Worth, I've lived here for two years at another property and sadly it has gone down hill. I scheduled many tours and walk throughs, BUT I heard many great things about the Mercantile. I got to meet Noelle and she took the time to show two units that were available within my timeframe. Needless to say I made the decision go with the Mercantile and I couldn't be happier, they were more than accommodating and made my move in as stress free as possible. I can't thank the great staff, NOELLE MITCHELL especially for helping me find my new home! 😁",
      "date": "2026-02-12",
      "title": ""
    },
    {
      "id": "custom_da03aef2-f97d-4c13-9d72-ec41031b9eff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "rating": "5.0",
      "name": "Vandy H.",
      "text": "It’s a great experience living here! The property is always clean, well-maintained, and feels safe, which was really important to me when choosing a place. The amenities are solid, and any maintenance requests I’ve submitted have been handled quickly and professionally.\n\nWhat really makes this place stand out though is the staff, especially Noelle and Halie. They’ve both been incredibly helpful, patient, and welcoming from day one. Whether it was answering questions, helping with paperwork, or just being friendly around the office, they made the whole process smooth and stress-free. You can tell they genuinely care about the residents.\n\nIf you’re looking for an apartment with a comfortable environment, nice amenities, and supportive team, I definitely recommend checking this place out!",
      "date": "2026-02-26",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_4c116e922ed34be71bf93e9e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f14c3-b48e-7047-9e08-fd8370c9dcc5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-b48e-7047-9e08-fd8370c9dcc5",
        "storage_key": "property/5712550654115840/019f14c3-b48e-7047-9e08-fd8370c9dcc5.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Mercantile River District - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/xYdHyDhEohk"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-dcb6-77e0-bf78-68e240215012",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "mercantile-river-district",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840"
    },
    {
      "lead_collector_id": "0198aa45-dd19-704e-ab9d-c38336b7fb7a",
      "lead_source": "FACEBOOK_ADS",
      "name": "mercantile-river-district",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840"
    },
    {
      "lead_collector_id": "0198aa45-dd7d-71aa-83c2-97a4bba99b05",
      "lead_source": "LANDING_PAGE",
      "name": "mercantile-river-district",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-ft-worth-889",
      "search_query": "luxury apartments with pool in Fort Worth",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Ft Worth",
      "h2_subtitle": "Explore the finest luxury apartments with pool access in Fort Worth. Dive into elegance at Mercantile River District and make a splash in style.",
      "page_copy": "Discover the epitome of upscale living at Mercantile River District, offering luxury apartments with a pool in Fort Worth. Nestled in the vibrant River District, our community provides a serene escape with modern comforts. Choose from a variety of layouts, including chic studios and three-bedroom units, each designed with thoughtful details. Dive into our sparkling pool or unwind with the convenience of smart home technologies.\n\nOur distinctive amenities set us apart, featuring a lazy river and unique outdoor spaces that enhance your lifestyle. Located in Tarrant County, Mercantile River District is the perfect blend of sophistication and leisure, offering a premier living experience. Visit us today and explore the unmatched luxury that awaits at our Fort Worth community. Whether you want to relax by the pool or join a game room experience, our residences are tailored for the discerning resident seeking the perfect balance of recreation and refinement.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool Ft Worth",
      "seo_description": "Discover luxury apartments with a pool in Fort Worth at Mercantile River District. Experience upscale amenities and modern living solutions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "smart-home-apartments-river-district-338",
      "search_query": "smart home apartments in River District",
      "category": "Amenity",
      "h1_title": "Smart Home Apartments in River District",
      "h2_subtitle": "Discover smart home apartments in Fort Worth's River District. Experience cutting-edge living at Mercantile River District today.",
      "page_copy": "Experience the future of living at Mercantile River District, where smart home apartments in the River District of Fort Worth offer technology-driven convenience and style. Our homes are equipped with state-of-the-art smart features that make daily living seamless and efficient. Whether you're adjusting the temperature or managing security from your phone, our aim is to enhance your life with the latest innovations.\n\nLocated in the vibrant River District, our community brings together the charm of Fort Worth living with modern amenities, including a refreshing pool, a stylish game room, and lush outdoor spaces. Choose our sophisticated studio to three-bedroom layouts, each thoughtfully designed with the resident in mind, and experience a seamless blend of luxury and technology. Discover how easy life can be in these smart home apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart Home Apartments in River District",
      "seo_description": "Explore smart home apartments in the River District at Mercantile River District. Modern living with cutting-edge technology and amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "apartments-with-lazy-river-tarrant-county-138",
      "search_query": "apartments with lazy river in Tarrant County",
      "category": "Amenity",
      "h1_title": "Apartments with Lazy River in Tarrant County",
      "h2_subtitle": "Experience unique apartment living with a lazy river in Tarrant County. Mercantile River District offers exclusive amenities for relaxation.",
      "page_copy": "Welcome to Mercantile River District, where you'll find exceptional apartments with a lazy river in Tarrant County. Our community redefines luxury living with a unique lazy river feature, perfect for those seeking relaxation right at home. Nestled in the vibrant area of Fort Worth's River District, our apartments offer a variety of spacious floor plans from studios to three-bedroom units, all designed with comfort and style in mind.\n\nBeyond the lazy river, residents enjoy access to numerous amenities including a refreshing pool, a modern game room, and outdoor spaces for leisure and play. Located in the heart of Tarrant County, Mercantile River District provides a tranquil escape with easy access to urban conveniences. Discover the difference today and see why our community is the perfect blend of unique luxury and everyday comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Lazy River in Tarrant County",
      "seo_description": "Find apartments with a lazy river in Tarrant County at Mercantile River District. Enjoy relaxation and luxury living in Fort Worth's River District.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-76114-306",
      "search_query": "fitness center apartments 76114",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in 76114",
      "h2_subtitle": "Discover premier fitness center apartments in the 76114 area. Mercantile River District offers top amenities for active lifestyles.",
      "page_copy": "If you're searching for fitness center apartments in the 76114 area, look no further than Mercantile River District. Situated in Fort Worth's vibrant neighborhood, our community offers state-of-the-art facilities designed to elevate your active lifestyle. Beyond our modern fitness center, residents enjoy a range of luxurious amenities including a sparkling pool, a unique lazy river, and expansive outdoor areas.\n\nOffering a selection of thoughtfully designed floor plans, from cozy studios to expansive three-bedroom homes, Mercantile River District caters to diverse needs while promoting a healthy, balanced lifestyle. Come explore life at our active community, where convenience meets elegance in the heart of Tarrant County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 76114",
      "seo_description": "Explore fitness center apartments in the 76114 area at Mercantile River District. Enjoy active living with luxury amenities in Fort Worth.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "game-room-apartments-near-downtown-fort-worth-900",
      "search_query": "game room apartments near downtown Fort Worth",
      "category": "Amenity",
      "h1_title": "Game Room Apartments near Downtown Fort Worth",
      "h2_subtitle": "Discover fun-filled game room apartments near downtown Fort Worth at Mercantile River District. Enjoy modern living and recreational amenities.",
      "page_copy": "For those searching for game room apartments near downtown Fort Worth, Mercantile River District offers the perfect blend of entertainment and convenience. Our community boasts a modern game room, providing an ideal space to unwind and socialize just a short distance from the city's vibrant center. Nestled in the scenic River District, our apartments feature various layouts, from intimate studios to expansive three-bedroom homes.\n\nBeyond the game room, residents enjoy a suite of luxurious amenities including a lazy river, a sparkling pool, and beautifully landscaped outdoor spaces. Located in the heart of Tarrant County, Mercantile River District combines urban access with serene living. Experience dynamic urban living with unmatched amenities to enhance your lifestyle today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Game Room Apartments near Downtown Fort Worth",
      "seo_description": "Find game room apartments near downtown Fort Worth at Mercantile River District. Enjoy recreational amenities and modern living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "studio-apartments-river-district-ft-worth-324",
      "search_query": "studio apartments river district ft worth",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in River District, Ft Worth",
      "h2_subtitle": "Explore stylish studio apartments in River District, Ft Worth. Mercantile River District offers modern living with exceptional amenities.",
      "page_copy": "Discover the perfect home at Mercantile River District, offering chic studio apartments in the vibrant River District of Fort Worth. Our thoughtfully designed studios maximize space and comfort, providing a modern retreat with access to luxurious amenities that include a lazy river, state-of-the-art fitness center, and a versatile game room.\n\nPositioned in Fort Worth's dynamic River District, our studio apartments offer a serene escape with convenient proximity to the bustling city life. Residents enjoy the tranquility of beautifully landscaped outdoor areas and the excitement of exclusive features like the sparkling pool. Experience contemporary living made simple and sophisticated in one of Tarrant County's prime locations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in River District, Ft Worth",
      "seo_description": "Find stylish studio apartments in River District, Ft Worth at Mercantile River District. Enjoy modern spaces and luxury amenities in a vibrant neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-fort-worth-tx-788",
      "search_query": "one bedroom apartments fort worth tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Fort Worth, TX",
      "h2_subtitle": "Discover cozy one bedroom apartments in Fort Worth, TX. Mercantile River District offers comfort and elegance with top amenities.",
      "page_copy": "Explore the perfect blend of comfort and style with one bedroom apartments at Mercantile River District in Fort Worth, TX. Our thoughtfully crafted spaces offer a cozy retreat with modern finishes and fittings, ideal for those seeking a balance of functionality and aesthetics. Situated in the lively River District, residents have access to a unique blend of urban conveniences and serene living.\n\nAmenities abound in our community, where you can enjoy leisurely afternoons by the lazy river or energize your day at the fully-equipped fitness center. With easy access to downtown Fort Worth, our one bedroom apartments provide a sophisticated living experience with unrivaled amenities, making them a desirable choice for anyone looking to call the River District home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Fort Worth, TX",
      "seo_description": "Find cozy one bedroom apartments in Fort Worth, TX at Mercantile River District. Enjoy modern living with top-notch amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-tarrant-county-428",
      "search_query": "two bedroom apartments tarrant county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Tarrant County",
      "h2_subtitle": "Explore spacious two bedroom apartments in Tarrant County at Mercantile River District. Enjoy modern living with exceptional amenities.",
      "page_copy": "At Mercantile River District, our two bedroom apartments in Tarrant County offer the perfect mix of space, comfort, and modern design. Located in the heart of the River District in Fort Worth, these spacious homes are ideal for individuals or families seeking room to thrive in a vibrant community setting. Each apartment is designed with contemporary features, ensuring a welcoming environment.\n\nResidents of Mercantile River District benefit from a host of top-tier amenities, including a tranquil lazy river, a sparkling pool, and a dynamic game room. This community is a stone's throw from downtown Fort Worth, providing the best of city living with a peaceful suburban feel. Discover the ideal two-bedroom apartment where modern conveniences and thoughtful amenities create a truly exceptional living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Tarrant County",
      "seo_description": "Find spacious two bedroom apartments in Tarrant County at Mercantile River District. Enjoy modern amenities and community living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-76114-536",
      "search_query": "three bedroom apartments near 76114",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 76114",
      "h2_subtitle": "Discover family-friendly three bedroom apartments near 76114 at Mercantile River District. Spacious, modern living in a vibrant community.",
      "page_copy": "For those seeking ample room and comfort, the three bedroom apartments at Mercantile River District near the 76114 area provide an ideal setting. Perfect for families or individuals needing extra space, these thoughtfully designed homes offer modern living within a lively community. Each apartment showcases high-end finishes and smart layouts that cater to the demands of contemporary lifestyles.\n\nSituated in the dynamic River District of Fort Worth, Mercantile River District provides residents with easy access to essential amenities, including a sparkling pool, lazy river, and state-of-the-art fitness facilities. Enjoy the balance of tranquility and the vibrancy of city life, only minutes from downtown Fort Worth. Here, family-friendly living is complemented by the community's exceptional offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 76114",
      "seo_description": "Spacious three bedroom apartments near 76114 at Mercantile River District. Enjoy family-friendly living with top amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "apartments-near-tarrant-co-coll-trinity-river-district-382",
      "search_query": "apartments near tarrant co coll trinity river district",
      "category": "School",
      "h1_title": "Apartments Near Tarrant Co Coll Trinity River",
      "h2_subtitle": "Find desirable apartments near Tarrant Co Coll Trinity River at Mercantile River District. Modern living close to education and recreation.",
      "page_copy": "Discover the ease of living near the Tarrant County College Trinity River Campus with our apartments at Mercantile River District. Conveniently located, these homes provide direct access to both academic pursuits and leisure activities, making them ideal for students and professionals alike. Enjoy modern interiors and smart home features that cater to a contemporary lifestyle.\n\nResidents here benefit from exceptional amenities within the vibrant River District of Fort Worth. You can unwind by the lazy river or stay active with our top-tier fitness facilities. With its proximity to education and lush green spaces, Mercantile River District offers a perfect balance of convenience and recreation, turning your apartment into more than just a home but a lifestyle choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tarrant Co Coll Trinity River",
      "seo_description": "Apartments near Tarrant Co Coll Trinity River at Mercantile River District. Experience modern living with easy access to education and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "apartments-close-to-texas-christian-university-ft-worth-866",
      "search_query": "apartments close to texas christian university ft worth",
      "category": "School",
      "h1_title": "Apartments Close to Texas Christian University",
      "h2_subtitle": "Explore convenient apartments close to Texas Christian University in Fort Worth. Enjoy luxurious living with top amenities at Mercantile River District.",
      "page_copy": "Looking for the perfect place to call home near Texas Christian University? Mercantile River District in Fort Worth offers apartments that blend convenience and style just a short drive away from TCU. These thoughtfully designed homes provide an ideal living environment for students, faculty, or anyone eager to stay close to the campus while enjoying upscale amenities.\n\nNestled in the River District, our community boasts a range of luxury features including a sparkling pool and a relaxing lazy river to unwind after a day of classes or work. With modern amenities and a vibrant neighborhood atmosphere, Mercantile River District ensures you’re always connected to both academic and city life. Discover the ideal blend of comfort and convenience close to Texas Christian University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Texas Christian University",
      "seo_description": "Find luxurious apartments close to Texas Christian University at Mercantile River District in Fort Worth. Ideal for students and faculty looking for proximity and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "apartments-near-tarrant-co-coll-north-west-tarrant-county-110",
      "search_query": "apartments near tarrant co coll north west tarrant county",
      "category": "School",
      "h1_title": "Apartments Near Tarrant Co Coll North West",
      "h2_subtitle": "Discover vibrant apartments near Tarrant Co Coll North West in Tarrant County. Experience modern comforts at Mercantile River District.",
      "page_copy": "At Mercantile River District, find your ideal apartment conveniently located near Tarrant County College's North West Campus. These stylish and comfortable homes offer easy accessibility to educational facilities, making them perfect for students and educators looking to minimize commute time while maximizing convenience.\n\nOur Fort Worth community embraces modern living with a variety of amenities designed to enhance your everyday experience. From the inviting lazy river to expansive outdoor spaces, there’s always a way to unwind and relax. Situated in the lively River District, these apartments promise the perfect blend of educational proximity and leisure opportunities, connecting you seamlessly to the heart of Tarrant County life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tarrant Co Coll North West",
      "seo_description": "Live near Tarrant Co Coll North West in Tarrant County with outstanding amenities at Mercantile River District. Perfect for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "apartments-close-to-texas-wesleyan-university-ft-worth-536",
      "search_query": "apartments close to texas wesleyan university ft worth",
      "category": "School",
      "h1_title": "Apartments Close to Texas Wesleyan University",
      "h2_subtitle": "Explore apartments close to Texas Wesleyan University in Fort Worth. Enjoy a vibrant community with top amenities at Mercantile River District.",
      "page_copy": "Discover the ideal living experience at Mercantile River District, offering exceptional apartments just a short drive from Texas Wesleyan University in Fort Worth. Whether you're a student seeking a convenient lifestyle or faculty desiring a modern home, these apartments offer the perfect blend of proximity and comfort.\n\nNestled within the vibrant River District, our community features luxurious amenities such as a shimmering pool and a relaxing lazy river, perfect for unwinding. With smart home features and appealing outdoor spaces, residents can enjoy contemporary living while staying connected to the educational opportunities at Texas Wesleyan University. Find the right balance between work, study, and serene living at Mercantile River District.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Texas Wesleyan University",
      "seo_description": "Find apartments close to Texas Wesleyan University in Fort Worth at Mercantile River District. A perfect blend of convenience and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "apartments-near-a-v-cato-elementary-school-ft-worth-184",
      "search_query": "apartments near a v cato elementary school ft worth",
      "category": "School",
      "h1_title": "Apartments Near A V Cato Elementary School",
      "h2_subtitle": "Discover family-friendly apartments near A V Cato Elementary School in Fort Worth. Enjoy a community with top-notch amenities at Mercantile River District.",
      "page_copy": "For families seeking a home near A V Cato Elementary School, Mercantile River District in Fort Worth offers the perfect solution. Our community is ideal for those who prioritize proximity to top educational institutions while enjoying a vibrant and secure living environment.\n\nLocated in the attractive River District, our apartments provide luxurious amenities such as a sparkling pool and expansive outdoor spaces, ideal for children and families to relax and play. With various floor plans available, from cozy studios to spacious three-bedroom homes, Mercantile River District is a great place to balance family life with convenience and leisure in Fort Worth.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near A V Cato Elementary School",
      "seo_description": "Find family-friendly apartments near A V Cato Elementary School in Fort Worth at Mercantile River District. Perfect for families valuing education and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "apartments-near-marsh-middle-school-76114-825",
      "search_query": "apartments near marsh middle school 76114",
      "category": "School",
      "h1_title": "Apartments Near Marsh Middle School 76114",
      "h2_subtitle": "Explore convenient living with apartments near Marsh Middle School in the 76114 area. Mercantile River District offers prime amenities and location.",
      "page_copy": "Situated in Fort Worth's vibrant River District, Mercantile River District offers an ideal community for those seeking apartments near Marsh Middle School in the 76114 area. Our homes are a perfect fit for families, offering not only convenient location but also a stunning array of amenities to enhance your living experience.\n\nChoose from a variety of floor plans, providing the right space for every family size. Enjoy the modern luxuries of our community, from the relaxing lazy river to spacious outdoor areas ideal for gatherings and family activities. At Mercantile River District, enjoy a harmonious blend of education, leisure, and contemporary living just moments away from Marsh Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Marsh Middle School 76114",
      "seo_description": "Find top-notch apartments near Marsh Middle School in the 76114 zip code at Mercantile River District. Ideal for families seeking convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "apartments-close-to-castleberry-high-school-ft-worth-459",
      "search_query": "apartments close to castleberry high school ft worth",
      "category": "School",
      "h1_title": "Apartments Close to Castleberry High School",
      "h2_subtitle": "Discover apartments close to Castleberry High School in Fort Worth. Enjoy prime amenities and vibrant living at Mercantile River District.",
      "page_copy": "For families and individuals looking for a convenient home near Castleberry High School, Mercantile River District in Fort Worth presents an excellent choice. Located in the lively River District, our community offers quick access to quality education and a rich array of features designed for modern living.\n\nMercantile River District boasts a range of spacious floor plans, from intimate studios to larger three-bedroom apartments. Residents can unwind in luxury with amenities such as a shimmering pool and relaxing lazy river, ideal for stress-free downtime. Our smart home features and ample outdoor spaces further enhance the living experience, making it an attractive option for those wanting proximity to Castleberry High School and the vibrant Fort Worth community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Castleberry High School",
      "seo_description": "Find apartments close to Castleberry High School in Fort Worth at Mercantile River District. Experience modern living and proximity to education.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "apartments-near-holy-family-catholic-school-ft-worth-708",
      "search_query": "apartments near holy family catholic school ft worth",
      "category": "School",
      "h1_title": "Apartments Near Holy Family Catholic School",
      "h2_subtitle": "Live near Holy Family Catholic School in Fort Worth. Mercantile River District offers luxurious apartments in a family-friendly community.",
      "page_copy": "Nestled in Fort Worth's dynamic River District, Mercantile River District provides a perfect setting for those seeking apartments near Holy Family Catholic School. Our community offers both convenience and comfort, making it an ideal choice for families who value education and leisure.\n\nOur diverse selection of floor plans ensures you find the perfect home, whether you're looking for a cozy studio or a larger three-bedroom apartment. With amenities like a sparkling pool and a laid-back lazy river, relaxation is always at your fingertips. These features, coupled with our modern smart home technology, make Mercantile River District an excellent place to thrive near Holy Family Catholic School and enjoy the Fort Worth lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Holy Family Catholic School",
      "seo_description": "Discover apartments near Holy Family Catholic School in Fort Worth at Mercantile River District. Enjoy family-friendly living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712550654115840",
      "source": "custom",
      "page_item_url": "apartments-close-to-all-saints-episcopal-school-fort-worth-995",
      "search_query": "apartments close to all saints' episcopal school of fort worth",
      "category": "School",
      "h1_title": "Apartments Close to All Saints' Episcopal School",
      "h2_subtitle": "Experience quality living near All Saints' Episcopal School in Fort Worth. Mercantile River District offers a perfect blend of convenience and luxury.",
      "page_copy": "Located in Fort Worth's lively River District, Mercantile River District is the premium choice for those seeking apartments close to All Saints' Episcopal School. Our community places you within easy reach of this prestigious institution, providing a perfect mix of convenience and quality living.\n\nResidents enjoy a variety of floor plans, ranging from stylish studios to expansive three-bedroom homes, each designed with modern comfort in mind. Indulge in our luxurious amenities, such as a serene lazy river and inviting outdoor spaces perfect for family relaxation. With these features, paired with smart home technology, living at Mercantile River District ensures a refined lifestyle, ideal for families desiring proximity to All Saints' Episcopal School and Fort Worth's dynamic environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area with a gray sofa, coffee table, and island.",
        "public_id": "019f6c0f-de89-7765-a5ac-557ef6224f42",
        "storage_key": "property/5712550654115840/019f6c0f-de89-7765-a5ac-557ef6224f42.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to All Saints' Episcopal School",
      "seo_description": "Find perfect apartments close to All Saints' Episcopal School in Fort Worth at Mercantile River District. Enjoy luxury and convenience in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2177"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470994"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a3a\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a3a\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4810271"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MQJ9F4Z"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://mercantile.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443276572"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/m9pzydezvk1"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/e378b1be-89f6-468a-a187-68a4c17d10c7"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "817-497-8387"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik82RGw5SnVTMkxkOVU1blA0WnBmVWc9PSIsInZhbHVlIjoib1IxVVRCVnZVZWp1LzhGT1RmVWR0UT09IiwibWFjIjoiNTYzNGVjZDQyODEzYTUzZDIzNWU0ODY1ZWU3ZmIyYjM4YmI5ZDJjYTFiZDE0ZDVkYjg1OTRhYjdlMjE4YjhmOCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2177",
  "custom_repli_id": "2376470994",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a3a\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a3a\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4810271",
  "custom_google_gtm_id": "GTM-MQJ9F4Z",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "none",
  "custom_betterbot_script": "<script src=\"https://mercantile.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443276572",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/m9pzydezvk1",
  "custom_self_guided_tour_url": "https://selftournow.com/property/e378b1be-89f6-468a-a187-68a4c17d10c7",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "817-497-8387",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik82RGw5SnVTMkxkOVU1blA0WnBmVWc9PSIsInZhbHVlIjoib1IxVVRCVnZVZWp1LzhGT1RmVWR0UT09IiwibWFjIjoiNTYzNGVjZDQyODEzYTUzZDIzNWU0ODY1ZWU3ZmIyYjM4YmI5ZDJjYTFiZDE0ZDVkYjg1OTRhYjdlMjE4YjhmOCJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "b1dd19ff-d8d9-4c7d-885a-bda4aea84753",
  "custom_audioeye_site_hash": "1aee2c2251038abe9c38735b80908280"
};

export const generatedAt = '2026-11-03T20:33:17.171Z';
